import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
	providedIn: 'root'
})
export class TextConstantsService {
	public l: string = 'de';

	constructor(
		private storage: Storage
	) {
		this.getLanguage();
	}
	async getLanguage() {
		// if (Object.keys(this.p.settings).length === 0) {
		// 	setTimeout((_this) => {
		// 		_this.getLanguage()
		// 	}, 100, this);
		// } else {
		// 	await this.checkConstants('it', 'en');
		// 	this.l = await this.storage.get('langCms');
		// 	if (!this.l) { this.l = this.p.settings.shopDefaultLanguages };
		// 	if (!this.l) { this.l = 'de' };

		// 	this.l = this.l.replace(/\s/g, '').replace('ENG', 'en').replace('DEU', 'de').replace('RUS', 'ru').replace('ITA', 'it');

		// }
	}

	async checkConstants(source, target) {
		const exclude: any[] = ['l', 'storage', 'p', 'checkConstants', 'setLanguage', 'getLanguage'];
		for (let key of Object.keys(this)) {
			if (!exclude.includes(key)) {
				if (!this[key].it || this[key].it === '') {
					this[key].it = this[key].en ? this[key].en : key;
				}
			}
		}
	}

	setLanguage(lang) {
		this.l = lang || 'de'
		this.storage.set('langCms', lang);
	}

	langShort: any = {
		it: 'ITA',
		de: 'DEU',
		deDu: 'De (du)',
		en: 'ENG',
		ru: 'RUS',
	}
	de: any = {
		it: 'Tedesco',
		de: 'Deutsch',
		deDu: 'Deutsch',
		en: 'German',
		ru: 'Немецкий',
	}
	deDu: any = {
		it: 'Tedesco',
		de: 'Deutsch',
		deDu: 'Deutsch',
		en: 'German',
		ru: 'Немецкий',
	}
	en: any = {
		it: 'Inglese',
		de: 'Englisch',
		deDu: 'Englisch',
		en: 'English',
		ru: 'Английский',
	}
	ru: any = {
		it: 'Russo',
		de: 'Russisch',
		deDu: 'Russisch',
		en: 'Russian',
		ru: 'Русский',
	}
	it: any = {
		it: 'Italiano',
		de: 'Italienisch',
		deDu: 'Italienisch',
		en: 'Italian',
		ru: 'Итальянский',
	}

	// LOCKER HEADER
	ausloggen: any = {
		it: 'esci',
		de: 'Ausloggen',
		deDu: 'Ausloggen',
		en: 'Logout',
		ru: 'Выйти'
	}
	habenSieDasFach: any = {
		it: '',
		de: 'Haben Sie das Fach schon geleert und gesäubert?',
		deDu: 'Haben Sie das Fach schon geleert und gesäubert?',
		en: 'Is box empty and clean?',
		ru: 'Эта коробка пустая и чистая?'
	}
	jaMieteBeenden: any = {
		it: '',
		de: 'Ja, Miete beenden',
		deDu: 'Ja, Miete beenden',
		en: 'Yes, I want to end my rental',
		ru: 'Да, прекратить аренду'
	}
	nachzahlungErforderlich: any = {
		it: '',
		de: 'Nachzahlung erforderlich',
		deDu: 'Nachzahlung erforderlich',
		en: 'Payment required',
		ru: 'Требуется оплата'
	}
	sieHabenIhreFachmiete: any = {
		it: '',
		de: 'Sie haben Ihre Fachmiete um 3 Stunden überzogen. Tätigen Sie jetzt eine Nachzahlung, um den Inhalt des Fachs entnehmen zu können.',
		deDu: 'Sie haben Ihre Fachmiete um 3 Stunden überzogen. Tätigen Sie jetzt eine Nachzahlung, um den Inhalt des Fachs entnehmen zu können.',
		en: 'You exceeded your rental period by 3 hours. Payment necessary to access your box.',
		ru: 'Вы превысили срок аренды на 3 часа. Внесите оплату, чтобы иметь доступ к вашему ящику.'
	}
	zurKasse: any = {
		it: 'vai alla cassa',
		de: 'Zur Kasse',
		deDu: 'Zur Kasse',
		en: 'Proceed to checkout',
		ru: 'Перейти к оформлению заказа'
	}
	fachmieteEndetDemnachst: any = {
		it: '',
		de: 'Fachmiete endet demnächst',
		deDu: 'Fachmiete endet demnächst',
		en: 'Rental period ending soon',
		ru: 'Срок аренды скоро истечёт'
	}
	in60Minuten: any = {
		it: '',
		de: 'In 60 Minuten endet die Fachmiete. Bitte entnehmen Sie den Inhalt des Fachs vor Ablauf der Mietzeit.',
		deDu: 'In 60 Minuten endet die Fachmiete. Bitte entnehmen Sie den Inhalt des Fachs vor Ablauf der Mietzeit.',
		en: 'Rental period ending in 60 minutes. Please empty out your box before.',
		ru: 'Срок аренды заканчивается через 60 минут. Пожалуйста, опустошите содержимое отсека до окончания срока аренды.'
	}
	mitEinemKlick: any = {
		it: '',
		de: 'Mit einem Klick auf die Schaltfläche "Ja" bestätigen Sie, dass Sie den gesamten Inhalt aus dem angemieteten Fach entnommen haben und die Miete beenden möchten.',
		deDu: 'Mit einem Klick auf die Schaltfläche "Ja" bestätigen Sie, dass Sie den gesamten Inhalt aus dem angemieteten Fach entnommen haben und die Miete beenden möchten.',
		en: 'By choosing "yes" you confirm, that you did empty out your box and that you want to end the rental period.',
		ru: 'Выбирая "Да", вы подтверждаете, что опустошили ящик и хотите завершить аренду.'
	}
	zugangsdatenSchlussel: any = {
		it: 'credenziali',
		de: 'Zugangsdaten / Schlüssel',
		deDu: 'Zugangsdaten / Schlüssel',
		en: 'login data / key',
		ru: 'Вход данные / ключ'
	}
	wirHabenIhre: any = {
		it: '',
		de: 'Wir haben Ihre Zugangsdaten per E-Mail an Sie gesendet.',
		deDu: 'Wir haben Ihre Zugangsdaten per E-Mail an Sie gesendet.',
		en: 'We sent your login data via e-mail.',
		ru: 'Мы отправили вашы данные для входа по электронной почте.'
	}
	zugangsdatenAnzeigen: any = {
		it: '',
		de: 'Zugangsdaten anzeigen',
		deDu: 'Zugangsdaten anzeigen',
		en: 'Show login data',
		ru: 'Показать данные для входа'
	}
	nachzahlungNotig: any = {
		it: '',
		de: 'Nachzahlung nötig',
		deDu: 'Nachzahlung nötig',
		en: 'Payment required',
		ru: 'Требуется оплата'
	}
	mieteBeginntIn: any = {
		it: '',
		de: 'Miete beginnt in',
		deDu: 'Miete beginnt in',
		en: 'Rental starts in',
		ru: 'Начало аренды через'
	}
	restzeitMiete: any = {
		it: '',
		de: 'Restzeit (Miete)',
		deDu: 'Restzeit (Miete)',
		en: 'Rental time remaining',
		ru: 'Оставшееся время аренды'
	}
	zugangsdaten: any = {
		it: '',
		de: 'Zugangsdaten',
		deDu: 'Zugangsdaten',
		en: 'Login data',
		ru: 'Данные для входа'
	}
	bestellungen: any = {
		it: '',
		de: 'Bestellungen',
		deDu: 'Bestellungen',
		en: 'Orders',
		ru: 'Заказы'
	}
	konto: any = {
		it: 'conto',
		de: 'Konto',
		deDu: 'Konto',
		en: 'Account',
		ru: 'Учетная запись'
	}
	anmelden: any = {
		it: 'accedi',
		de: 'Anmelden',
		deDu: 'Anmelden',
		en: 'Login',
		ru: 'Войти'
	}
	zuruck: any = {
		it: 'indietro',
		de: 'Zurück',
		deDu: 'Zurück',
		en: 'Back',
		ru: 'Назад'
	}
	mieten: any = {
		it: 'affitto',
		de: 'Mieten',
		deDu: 'Mieten',
		en: 'Rental',
		ru: 'Аренда'
	}
	aktive: any = {
		it: 'attivo',
		de: 'Aktive',
		deDu: 'Aktive',
		en: 'Active',
		ru: 'Активная '
	}

	// LOCKER MAP

	anderenTagWaehlen: any = {
		it: '',
		de: 'Andere Startzeit wählen',
		deDu: 'Andere Startzeit wählen',
		en: 'Select another start time',
		ru: 'Выбрать другой день'
	}
	ca: any = {
		it: '',
		de: 'ca.',
		deDu: 'ca.',
		en: 'approx.',
		ru: 'около'
	}
	bitteWahlenSie: any = {
		it: '',
		de: 'Bitte wählen Sie einen Standort in der Karte aus, an dem Sie ein Fach mieten möchten.',
		deDu: 'Bitte wählen Sie einen Standort in der Karte aus, an dem Sie ein Fach mieten möchten.',
		en: 'Please choose the location on the map, where you want to rent a box.',
		ru: 'Пожалуйста, выберите место на карте, где вы хотели бы арендовать ячейку.'
	}
	standortWahlen: any = {
		it: '',
		de: 'Standort wählen',
		deDu: 'Standort wählen',
		en: 'Choose location',
		ru: 'Выбрать место'
	}
	mietdauerWahlen: any = {
		it: '',
		de: 'Mietdauer wählen',
		deDu: 'Mietdauer wählen',
		en: 'Choose rental period',
		ru: 'Выбрать срок аренды'
	}
	fachgrobeWahlen: any = {
		it: '',
		de: 'Fachgröße',
		deDu: 'Fachgröße wählen',
		en: 'Choose box size',
		ru: 'Выбрать размер ячейки'
	}
	onlineBezahlen: any = {
		it: '',
		de: 'Online bezahlen',
		deDu: 'Online bezahlen',
		en: 'Pay online',
		ru: 'Оплата онлайн'
	}
	artDerMiete: any = {
		it: '',
		de: 'Art der Miete',
		deDu: 'Art der Miete',
		en: 'Kind of rent',
		ru: 'Тип аренды'
	}
	zeitraumWahlen: any = {
		it: '',
		de: 'Zeitraum wählen',
		deDu: 'Zeitraum wählen',
		en: 'Choose rental period',
		ru: 'Выбрать тип аренды'
	}
	wannMochtenSie: any = {
		it: '',
		de: 'Wann möchten Sie ein Fach mieten?',
		deDu: 'Wann möchten Sie ein Fach mieten?',
		en: 'When do you want to rent your box?',
		ru: 'Когда вы хотите арендовать ячейку?'
	}
	mietenAbSofort: any = {
		it: '',
		de: 'Mieten ab sofort *',
		deDu: 'Mieten ab sofort *',
		en: 'Rent now *',
		ru: 'Арендовать сейчас *'
	}
	dieMieteDtartet: any = {
		it: '',
		de: '* Die Miete startet erst nach erfolgreicher online Zahlung.',
		deDu: '* Die Miete startet erst nach erfolgreicher online Zahlung.',
		en: '* The rental period only starts after successful online payment.',
		ru: '* Срок аренды начинается только после успешной онлайн-оплаты.'
	}
	minimaleMietdauer: any = {
		it: '',
		de: 'Minimale Mietdauer',
		deDu: 'Miniimale Mietdauer',
		en: 'Minimum rental period',
		ru: 'Минимальный срок аренды'
	}
	maximaleMietdauer: any = {
		it: '',
		de: 'Maximale Mietdauer',
		deDu: 'Maximale Mietdauer',
		en: 'Maximum rental period',
		ru: 'Максимальный срок аренды'
	}
	stunde: any = {
		it: 'ora',
		de: 'Hour',
		deDu: 'Hour',
		en: 'Hour',
		ru: 'Час'
	}
	stunden: any = {
		it: 'ore',
		de: 'Stunden',
		deDu: 'Stunden',
		en: 'Hours',
		ru: 'Час(а, ов)'
	}
	tag: any = {
		it: 'giorno',
		de: 'Tag',
		deDu: 'Tag',
		en: 'Day',
		ru: 'День'
	}
	tage: any = {
		it: 'giorni',
		de: 'Tage',
		deDu: 'Tage',
		en: 'Days',
		ru: 'Дн(я, ей)'
	}
	woche: any = {
		it: 'settimana',
		de: 'Woche',
		deDu: 'Woche',
		en: 'Week',
		ru: 'Неделя'
	}
	wochen: any = {
		it: 'settimane',
		de: 'Wochen',
		deDu: 'Wochen',
		en: 'Weeks',
		ru: 'Недели'
	}

	freieFacherSuchen: any = {
		it: '',
		de: 'Freie Fächer suchen',
		deDu: 'Freie Fächer suchen',
		en: 'Choose available box',
		ru: 'Выбрать доступную ячейку'
	}
	andereKundenWahlten: any = {
		it: '',
		de: 'Andere Kunden wählten auch',
		deDu: 'Andere Kunden wählten auch',
		en: 'Other customers also chose',
		ru: 'Другие клиенты также выбрали'
	}
	wennSieMehr: any = {
		it: '',
		de: 'Wenn Sie mehr als einen Tag auswählen, wird die Uhrzeit automatisch ausgewählt.<br />Maximale Mietdauer',
		deDu: 'Wenn Sie mehr als einen Tag auswählen, wird die Uhrzeit automatisch ausgewählt.<br />Maximale Mietdauer',
		en: 'For rental durations of one day and more, the time is being set automatically.<br />Maximum rental period',
		ru: 'При сроке аренды от суток и более, время устанавливается автоматически.<br />Максимальный срок аренды'
	}
	startzeit: any = {
		it: '',
		de: 'Startzeit',
		deDu: 'Startzeit',
		en: 'Starting time',
		ru: 'Время начала'
	}
	endzeit: any = {
		it: '',
		de: 'Endzeit',
		deDu: 'Endzeit',
		en: 'Ending time',
		ru: 'Время окончания'
	}
	mietdauer: any = {
		it: '',
		de: 'Mietdauer',
		deDu: 'Mietdauer',
		en: 'Rental period',
		ru: 'Срок аренды'
	}
	abbrechen: any = {
		it: 'cancellare',
		de: 'Cancel',
		deDu: 'Cancel',
		en: 'Cancel',
		ru: 'Отмена'
	}
	proStunde: any = {
		it: 'a ora',
		de: 'pro Stunde',
		deDu: 'pro Stunde',
		en: 'per hour',
		ru: 'в час'
	}
	pro: any = {
		it: 'per',
		de: 'pro ',
		deDu: 'pro ',
		en: 'per ',
		ru: 'в '
	}
	auswahlNichtVerfugbar: any = {
		it: 'non disponibile',
		de: 'Auswahl nicht verfügbar',
		deDu: 'Auswahl nicht verfügbar',
		en: 'Chosen options not available',
		ru: 'Выбранные параметры недоступны'
	}
	dieGewunschteFachgrobe: any = {
		it: '',
		de: 'Die gewünschte Fachgröße ist jedoch an einem anderen Standort in der Nähe verfügbar',
		deDu: 'Die gewünschte Fachgröße ist jedoch an einem anderen Standort in der Nähe verfügbar',
		en: 'The chosen box size is available in another location.',
		ru: 'Выбранный размер ячейки доступен в другом месте'
	}
	bitteMietdauerWahlen: any = {
		it: '',
		de: 'Bitte Mietdauer wählen',
		deDu: 'Bitte Mietdauer wählen',
		en: 'Please choose rental period',
		ru: 'Пожалуйста, выберите период аренды'
	}
	mochtenSieStattdessen: any = {
		it: '',
		de: 'Möchten Sie stattdessen dort buchen?',
		deDu: 'Möchten Sie stattdessen dort buchen?',
		en: 'Would you like to book there instead?',
		ru: 'Вы хотите забронировать там вместо этого?'
	}
	maxMustermannStrabe: any = {
		it: '',
		de: 'Max Mustermann Straße',
		deDu: 'Max Mustermann Straße',
		en: 'Max Mustermann Street',
		ru: 'Улица Макс Мустерманн'
	}
	fachgrobeNichtVerfugbar: any = {
		it: '',
		de: 'Fachgröße nicht verfügbar',
		deDu: 'Fachgröße nicht verfügbar',
		en: 'Box size not available',
		ru: 'Размер ячейки недоступен'
	}
	mochtenSieStattdessenAuf: any = {
		it: '',
		de: 'Möchten Sie stattdessen auf das<br />nächstgrößere Fach ausweichen?',
		deDu: 'Möchten Sie stattdessen auf das<br />nächstgrößere Fach ausweichen?',
		en: 'Would you like to book an alternate<br />box one size larger?',
		ru: 'Хотите вместо этой ячейки забронировать<br />другую на один размер больше?'
	}
	buchungInDer: any = {
		it: '',
		de: 'Buchung in der App abschließen',
		deDu: 'Buchung in der App abschließen',
		en: 'Finalize booking in the app',
		ru: 'Завершите бронирование в приложении'
	}
	oder: any = {
		it: 'oppure',
		de: 'oder',
		deDu: 'oder',
		en: 'or',
		ru: 'или'
	}
	anderungVornehmen: any = {
		it: '',
		de: 'Änderung vornehmen',
		deDu: 'Änderung vornehmen',
		en: 'Make a change',
		ru: 'Внести изменения'
	}
	jetztZugangHolen: any = {
		it: '',
		de: 'Jetzt Zugang holen',
		deDu: 'Jetzt Zugang holen',
		en: 'Obtain your access',
		ru: 'Получите доступ'
	}
	zugangsdatenPerEMail: any = {
		it: '',
		de: 'Zugangsdaten per E-Mail abrufen',
		deDu: 'Zugangsdaten per E-Mail abrufen',
		en: 'Obtain login data via e-mail',
		ru: 'Получить данные для входа по электронной почте'
	}
	schlusselAPP: any = {
		it: '',
		de: 'Schlüssel-APP herunterladen und anmelden',
		deDu: 'Schlüssel-APP herunterladen und anmelden',
		en: 'Download the key-app and login',
		ru: 'Загрузите приложение-ключ и войдите в систему'
	}
	schlieben: any = {
		it: 'chiudi',
		de: 'Schließen',
		deDu: 'Schließen',
		en: 'Close',
		ru: 'Закрыть'
	}
	sindSieNoch: any = {
		it: 'sei ancora in linea?',
		de: 'Sind Sie noch da?',
		deDu: 'Sind Sie noch da?',
		en: 'Are you still here?',
		ru: 'Вы ещё здесь?'
	}
	jaIchBin: any = {
		it: 'si, sono ancora qui',
		de: 'Ja, ich bin hier',
		deDu: 'Ja, ich bin hier',
		en: 'Yes, I am here',
		ru: 'Да, я здесь'
	}
	bitteFachgrobeWahlen: any = {
		it: '',
		de: 'Bitte Fachgröße wählen',
		deDu: 'Bitte Fachgröße wählen',
		en: 'Please choose a box size',
		ru: 'Пожалуйста, выберите размер ячейки'
	}
	fachgrobe: any = {
		it: '',
		de: 'Locker size',
		deDu: 'Locker size',
		en: 'Locker size',
		ru: 'Размер ячейки'
	}
	hohe: any = {
		it: 'altezza',
		de: 'Höhe',
		deDu: 'Höhe',
		en: 'Height',
		ru: 'Высота'
	}
	breite: any = {
		it: 'larghezza',
		de: 'Breite',
		deDu: 'Breite',
		en: 'Width',
		ru: 'Ширина'
	}
	tiefe: any = {
		it: 'profondità',
		de: 'Tiefe',
		deDu: 'Tiefe',
		en: 'Depth',
		ru: 'Глубина'
	}
	hinweisDieGrafik: any = {
		it: '',
		de: '<br />Hinweis: Die Grafik dient nur zur Veranschaulichung der Fachgröße / Proportion.<br />Die tatsächliche Position des angemieteten Faches kann daher variieren.',
		deDu: '<br />Hinweis: Die Grafik dient nur zur Veranschaulichung der Fachgröße / Proportion.<br />Die tatsächliche Position des angemieteten Faches kann daher variieren.',
		en: '<br />Note: The graphic is only used to illustrate the box size / proportion.<br />The actual position of the rented compartment can therefore vary',
		ru: '<br />Примечание: картинка используется только для иллюстрации размера/пропорций ячейки.<br />Поэтому фактическое положение арендуемого отсека может отличаться.'
	}
	mietenFurEinen: any = {
		it: '',
		de: 'Mieten<span class="mobile-hidde"> für einen späteren Zeitpunkt</span>',
		deDu: 'Mieten<span class="mobile-hidde"> für einen späteren Zeitpunkt</span>',
		en: 'Rent<span class="mobile-hidde"> for a time in the future</span>',
		ru: 'Арендовать<span class="mobile-hidde"> на потом</span>'
	}
	mietbeginn: any = {
		it: '',
		de: 'Mietbeginn',
		deDu: 'Mietbeginn',
		en: 'Rental Starts',
		ru: 'Начало аренды'
	}
	nachZahlungseingang: any = {
		it: 'dopo il tuo pagamento',
		de: 'nach Zahlungseingang',
		deDu: 'nach Zahlungseingang',
		en: 'after receipt of payment',
		ru: 'после получения оплаты'
	}
	anDiesemStandort: any = {
		it: '',
		de: 'An diesem Standort sind zu den gewählten Zeiten, keine Fächer mehr verfügbar. Bitte probieren Sie einen anderen Zeitraum oder Standort aus.',
		deDu: 'An diesem Standort sind zu den gewählten Zeiten, keine Fächer mehr verfügbar. Bitte probieren Sie einen anderen Zeitraum oder Standort aus.',
		en: 'There are no more boxes available at this location at the selected times. Please try a different time period or location.',
		ru: 'В выбранное время в этом месте больше нет ячейки. Пожалуйста, попробуйте другой период времени или место.'
	}
	anDiesemStandortBR: any = {
		it: '',
		de: 'An diesem Standort sind zu den gewählten Zeiten, keine Fächer mehr verfügbar.<br />Bitte probieren Sie einen anderen Zeitraum oder Standort aus.',
		deDu: 'An diesem Standort sind zu den gewählten Zeiten, keine Fächer mehr verfügbar.<br />Bitte probieren Sie einen anderen Zeitraum oder Standort aus.',
		en: 'There are no more boxes available at this location at the selected times.<br />Please try a different time period or location.',
		ru: 'В выбранное время в этом месте больше нет ячейки.<br />Пожалуйста, попробуйте другой период времени или место.'
	}
	wahlen: any = {
		it: 'scegli',
		de: 'Wählen',
		deDu: 'Wählen',
		en: 'Choose',
		ru: 'Выбрать'
	}
	wasPasstRein: any = {
		it: 'cosa ci sta?',
		de: 'Was passt rein?',
		deDu: 'Was passt rein?',
		en: 'What fits in?',
		ru: 'Что подходит?'
	}
	abSofortBis: any = {
		it: 'da subito',
		de: 'Ab sofort bis',
		deDu: 'Ab sofort bis',
		en: 'From now to',
		ru: 'С этого времени до'
	}

	wahlenSieAuf: any = {
		it: '',
		de: 'Wählen Sie auf der Karte einen Schließfach Standort aus, indem Sie auf die gewünschte Markierung klicken.',
		deDu: 'Wähle auf der Karte einen Schließfach Standort aus, indem Sie auf die gewünschte Markierung klicken.',
		en: 'Select the desired location on the map by clicking on the marker.',
		ru: 'Выберите место на карте, нажав на нужный маркер.'
	}
	wahlenSieDen: any = {
		it: '',
		de: 'Wählen Sie die gewünschte Mietdauer.',
		deDu: 'Wähle die gewünschte Mietdauer.',
		en: 'Choose the desired rental period.',
		ru: 'Выберите желаемый период аренды.'
	}
	hierSindAlle: any = {
		it: '',
		de: 'Wählen Sie eine passende Fachgröße aus.',
		deDu: 'Wähle eine passende Fachgröße aus.',
		en: 'Here are all the sizes of the box, click the one that suits you.',
		ru: 'Вот все размеры ячеек, кликайте на ту, которая вам подходит.'
	}
	anDieserStelle: any = {
		it: '',
		de: 'Vervollständigen Sie Ihre Kontaktdaten und wählen Sie die gewünschte Zahlungsart aus.',
		deDu: 'Vervollständige deine Kontaktdaten und wählen die gewünschte Zahlungsart aus.',
		en: 'Complete your contact details and select the desired payment method.',
		ru: 'Заполните свои контактные данные и выберите желаемый способ оплаты.'
	}
	datenschutz: any = {
		it: 'Privacy',
		de: 'Datenschutz',
		deDu: 'Datenschutz',
		en: 'Privacy',
		ru: 'Конфиденциальность'
	}
	widerrufsbelehrung: any = {
		it: 'istruzioni sul recesso',
		de: 'Widerrufsbelehrung',
		deDu: 'Widerrufsbelehrung',
		en: 'Right of withdrawal',
		ru: 'Право на отзыв'
	}
	impressum: any = {
		it: 'informazione legale',
		de: 'Impressum',
		deDu: 'Impressum',
		en: 'Imprint',
		ru: 'Отпечаток'
	}
	alleRechteVorbehalten: any = {
		it: 'tutti i diritti sono riservati',
		de: 'Alle Rechte vorbehalten',
		deDu: 'Alle Rechte vorbehalten',
		en: 'All rights reserved',
		ru: 'Все права защищены'
	}
	nein: any = {
		it: 'No',
		de: 'Nein',
		deDu: 'Nein',
		en: 'No',
		ru: 'Нет'
	}
	ja: any = {
		it: 'Si',
		de: 'Ja',
		deDu: 'Ja',
		en: 'Yes',
		ru: 'Да'
	}
	standort: any = {
		it: 'Posizione',
		de: 'Standort',
		deDu: 'Standort',
		en: 'Location',
		ru: 'Расположение'
	}
	hinweis: any = {
		it: 'Avviso',
		de: 'Hinweis',
		deDu: 'Hinweis',
		en: 'Hint to your order',
		ru: 'Уведомление'
	}
	esWurdeDie: any = {
		it: '',
		de: "Ihre gewählte Mietdauer hat die maximale Dauer (' + this.settings.lockermapDefaultMaxRentTime + ') überschritten.",
		deDu: "Ihre gewählte Mietdauer hat die maximale Dauer (' + this.settings.lockermapDefaultMaxRentTime + ') überschritten.",
		en: 'Your chosen rental period is exceeding the maximum period.',
		ru: 'Выбранный вами период аренды превышает максимальный срок.'
	}
	diesesFach: any = {
		it: '',
		de: 'Dieses Fach befindet sich bereits in dem Warenkorb.',
		deDu: 'Dieses Fach befindet sich bereits in dem Warenkorb.',
		en: 'This box is already in the shopping cart.',
		ru: 'Эта ячейка уже в корзине.'
	}
	esSindNoch: any = {
		it: '',
		de: 'Es sind noch Nachzahlungen offen',
		deDu: 'Es sind noch Nachzahlungen offen',
		en: 'Additional payments are still outstanding',
		ru: 'Просроченные платежи ещё не оплачены'
	}
	sieKonnen: any = {
		it: '',
		de: 'Sie können erst wieder eine neue Miete starten, wenn die offenen Nachzahlungen beglichen sind.',
		deDu: 'Sie können erst wieder eine neue Miete starten, wenn die offenen Nachzahlungen beglichen sind.',
		en: 'You can only start a new lease once the outstanding back payments have been settled.',
		ru: 'Вы можете начать новую аренду только после того, как будут оплачены просроченные платежи.'
	}

	// CONTENT 

	blockTypWahlen: any = {
		it: '',
		de: 'Block Typ wählen',
		deDu: 'Block Typ wählen',
		en: 'Choose block type',
		ru: 'Выбрать тип блока'
	}
	artikelverwaltung: any = {
		it: 'Gestione degli articoli',
		de: 'Artikelverwaltung',
		deDu: 'Artikelverwaltung',
		en: 'Item Management',
		ru: 'Управление элементом'
	}
	texte: any = {
		it: 'Testi',
		de: 'Texte',
		deDu: 'Texte',
		en: 'Text',
		ru: 'Текст'
	}
	aktiv: any = {
		it: 'Attivo',
		de: 'Aktiv',
		deDu: 'Aktiv',
		en: 'Active',
		ru: 'Активный'
	}
	titel: any = {
		it: 'Titolo',
		de: 'Titel',
		deDu: 'Titel',
		en: 'Title',
		ru: 'Заголовок'
	}
	beschreibung: any = {
		it: 'Descrizione',
		de: 'Beschreibung',
		deDu: 'Beschreibung',
		en: 'Description',
		ru: 'Описание'
	}
	weitereAnzeigen: any = {
		it: 'Mostra altro',
		de: 'Weitere anzeigen',
		deDu: 'Weitere anzeigen',
		en: 'Show more',
		ru: 'Показать больше...'
	}
	artikelnummer: any = {
		it: 'Numero articolo',
		de: 'Artikelnummer',
		deDu: 'Artikelnummer',
		en: 'Item number',
		ru: 'Номер элемента'
	}
	ean: any = {
		it: 'EAN',
		de: 'EAN',
		deDu: 'EAN',
		en: 'EAN',
		ru: 'EAN'
	}
	hashtags: any = {
		it: 'Gli hastag',
		de: 'Hashtags',
		deDu: 'Hashtags',
		en: 'Hashtags',
		ru: 'Хэштеги'
	}
	preise: any = {
		it: 'Prezzi',
		de: 'Preise',
		deDu: 'Preise',
		en: 'Prices',
		ru: 'Цены'
	}
	preis: any = {
		it: 'Prezzo',
		de: 'Preis',
		deDu: 'Preis',
		en: 'Price',
		ru: 'Цена'
	}
	preisInkl: any = {
		it: 'Prezzo incluso IVA',
		de: 'Preis inkl. MwSt.',
		deDu: 'Preis inkl. MwSt.',
		en: 'Price incl. VAT.',
		ru: 'Цена включая НДС.'
	}
	mwStSatz: any = {
		it: 'IVA',
		de: 'MwSt. Satz',
		deDu: 'MwSt. Satz',
		en: 'VAT. rate',
		ru: 'Ставка НДС.'
	}
	dienstleistung: any = {
		it: 'Servizio',
		de: 'Dienstleistung',
		deDu: 'Dienstleistung',
		en: 'Service',
		ru: 'Услуги'
	}
	minuten: any = {
		it: 'Minuti',
		de: 'Minuten',
		deDu: 'Minuten',
		en: 'Minutes',
		ru: 'Минуты'
	}
	links: any = {
		it: 'Link',
		de: 'Links',
		deDu: 'Links',
		en: 'Links',
		ru: 'Ссылки'
	}
	linkText: any = {
		it: 'Testo del link',
		de: 'Link-Text',
		deDu: 'Link-Text',
		en: 'Link-Text',
		ru: 'Текст-ссылки'
	}
	linkURL: any = {
		it: 'Link-URL',
		de: 'Link-URL',
		deDu: 'Link-URL',
		en: 'Link-URL',
		ru: 'Адрес ссылки-URL'
	}
	bildURL: any = {
		it: 'URL della foto',
		de: 'Bild-URL',
		deDu: 'Bild-URL',
		en: 'Image-URL',
		ru: 'Изображение-URL'
	}
	bildBeschreibung: any = {
		it: 'Descrizione della foto',
		de: 'Bild-Beschreibung (SEO)',
		deDu: 'Bild-Beschreibung (SEO)',
		en: 'Image-description (SEO)',
		ru: 'Описание изображения (SEO)'
	}
	zusatzstoffe: any = {
		it: 'Gli aditivi',
		de: 'Zusatzstoffe',
		deDu: 'Zusatzstoffe',
		en: 'Additives',
		ru: 'Дополнительно'
	}
	optionenAnzeigen: any = {
		it: 'Mostra gli opzioni',
		de: 'Optionen anzeigen',
		deDu: 'Optionen anzeigen',
		en: 'Show options',
		ru: 'Показать параметры'
	}
	debugLog: any = {
		it: 'Debug Log',
		de: 'Debug Log',
		deDu: 'Debug Log',
		en: 'Debug Log',
		ru: 'Журнал отладки'
	}
	anzeigen: any = {
		it: 'Mostra',
		de: 'Anzeigen',
		deDu: 'Anzeigen',
		en: 'Show',
		ru: 'Показать'
	}
	symbolAuswahlen: any = {
		it: 'Scegli simbolo',
		de: 'Symbol auswählen',
		deDu: 'Symbol auswählen',
		en: 'Select icon',
		ru: 'Выбрать значек'
	}
	suchbegriff: any = {
		it: 'Termine di ricerca',
		de: 'Suchbegriff...',
		deDu: 'Suchbegriff...',
		en: 'Search...',
		ru: 'Поиск...'
	}
	suchbegriffEingeben: any = {
		it: 'Immetti il termine di ricerca',
		de: 'Suchbegriff eingeben...',
		deDu: 'Suchbegriff eingeben...',
		en: 'Enter a search term...',
		ru: 'Введите поисковый запрос...'
	}
	hinzufugenEinerSeite: any = {
		it: 'Aggiungi una pagina',
		de: 'Hinzufügen einer Seite',
		deDu: 'Hinzufügen einer Seite',
		en: 'Add a page',
		ru: 'Добавить страницу'
	}
	seiteVeroffentlicht: any = {
		it: '',
		de: 'Seite veröffentlicht',
		deDu: 'Seite veröffentlicht',
		en: 'Page published',
		ru: 'Страница опубликована'
	}
	wennDeaktiviert: any = {
		it: '',
		de: 'Wenn deaktiviert, ist die Seite nur für Sie sichtbar.',
		deDu: 'Wenn deaktiviert, ist die Seite nur für Sie sichtbar.',
		en: 'If disabled, the page is only visible to you.',
		ru: 'Если отключено, страницу видно только вам.'
	}
	navigation: any = {
		it: 'Navigazione',
		de: 'Navigation',
		deDu: 'Navigation',
		en: 'Navigation',
		ru: 'Навигация'
	}
	alsTabSmartphoneAnzeigen: any = {
		it: '',
		de: 'Als Tab (Smartphone) anzeigen',
		deDu: 'Als Tab (Smartphone) anzeigen',
		en: 'Show as tab (smartphone)',
		ru: 'Показать как вкладку (смартфон)'
	}
	symbol: any = {
		it: 'Simbolo',
		de: 'Symbol',
		deDu: 'Symbol',
		en: 'Symbol',
		ru: 'Символ'
	}
	legenSieEinIcon: any = {
		it: '',
		de: 'Legen Sie ein Icon, den Namen und die Reihenfolge des Tabs fest.',
		deDu: 'Legen Sie ein Icon, den Namen und die Reihenfolge des Tabs fest.',
		en: 'Specify an icon, the name and the order of the tab.',
		ru: 'Укажите значок, имя и порядок вкладки'
	}
	linkInKopfzeile: any = {
		it: '',
		de: 'Link in Kopfzeile anzeigen',
		deDu: 'Link in Kopfzeile anzeigen',
		en: 'Show link in header',
		ru: 'Показать ссылку в верху страницы'
	}
	linkInFubzeile: any = {
		it: '',
		de: 'Link in Fußzeile anzeigen',
		deDu: 'Link in Fußzeile anzeigen',
		en: 'Show link in footer',
		ru: 'Показать ссылку в низу страницы'
	}
	seiteHinzufugen: any = {
		it: 'Aggiungi una pagina',
		de: 'Seite hinzufügen',
		deDu: 'Seite hinzufügen',
		en: 'Add page',
		ru: 'Добавить страницу'
	}
	seiteSpeichern: any = {
		it: 'Salvi la pagina',
		de: 'Save',
		deDu: 'Save',
		en: 'Save page',
		ru: 'Сохранить страницу'
	}
	filiale: any = {
		it: '',
		de: 'Location',
		deDu: 'Location',
		en: 'Location',
		ru: 'Location'
	}
	filialverwaltung: any = {
		it: '',
		de: 'Filialverwaltung',
		deDu: 'Filialverwaltung',
		en: 'Branch management',
		ru: 'Управление филиалом'
	}
	panelZumVerwalten: any = {
		it: '',
		de: 'Panel zum Verwalten einer Buchung oder Bestellung von Waren.',
		deDu: 'Panel zum Verwalten einer Buchung oder Bestellung von Waren.',
		en: 'Panel for managing a booking or ordering of goods.',
		ru: 'Панель для управления бронированием или заказом товаров.'
	}
	seiten: any = {
		it: 'Pagine',
		de: 'Seiten',
		deDu: 'Seiten',
		en: 'Pages',
		ru: 'Страницы'
	}
	verwaltungDerUnterSeiten: any = {
		it: '',
		de: 'Verwaltung der (Unter-) Seiten. Sie können Seiten hinzufügen, entfernen sowie deren Funktionen bearbeiten.',
		deDu: 'Verwaltung der (Unter-) Seiten. Sie können Seiten hinzufügen, entfernen sowie deren Funktionen bearbeiten.',
		en: 'Management of the (sub)pages. You can add, remove and their edit functions.',
		ru: 'Управление (под-) страницами. Можно добавлять, удалять и редактировать их функции.'
	}
	veroffentlichteSeiten: any = {
		it: '',
		de: 'Veröffentlichte Seiten',
		deDu: 'Veröffentlichte Seiten',
		en: 'Published pages',
		ru: 'Опубликованные страницы'
	}
	versteckteSeiten: any = {
		it: '',
		de: 'Versteckte Seiten',
		deDu: 'Versteckte Seiten',
		en: 'Hidden pages',
		ru: 'Скрытые страницы'
	}
	erstelleDeinenErsten: any = {
		it: '',
		de: 'Erstelle deinen ersten',
		deDu: 'Erstelle deinen ersten',
		en: 'Create your first',
		ru: 'Создайте свой первый'
	}
	contentBlockAuf: any = {
		it: '',
		de: 'Content-Block auf dieser Seite',
		deDu: 'Content-Block auf dieser Seite',
		en: 'content block on this page',
		ru: 'блок контента на этой странице'
	}
	esGibtNochKeine: any = {
		it: '',
		de: 'Es gibt noch keine Inhalte auf dieser Seite',
		deDu: 'Es gibt noch keine Inhalte auf dieser Seite',
		en: 'There is no content on this page yet',
		ru: 'На этой странице пока нет контента'
	}

	blockLoschen: any = {
		it: 'Cancelli il blocco',
		de: 'Block löschen',
		deDu: 'Block löschen',
		en: 'Delete block',
		ru: 'Удалить блок'
	}
	fehler28: any = {
		it: 'Errore 28',
		de: 'Fehler 28',
		deDu: 'Fehler 28',
		en: 'Error 28',
		ru: 'Ошибка 28'
	}
	fehler32: any = {
		it: 'Errore 32',
		de: 'Fehler 32',
		deDu: 'Fehler 32',
		en: 'Error 32',
		ru: 'Ошибка 32'
	}
	inhalteKonnteNicht: any = {
		it: 'Il contenuto non poteva essere caricato',
		de: 'Inhalte konnten nicht geladen werden!',
		deDu: 'Inhalte konnten nicht geladen werden!',
		en: 'Content could not be loaded!',
		ru: 'Контент не может быть загружен!'
	}
	seiteKonnteNicht: any = {
		it: 'La pagina non poteva essere caricato',
		de: 'Seite konnte nicht geladen werden!',
		deDu: 'Seite konnte nicht geladen werden!',
		en: 'Page could not be loaded!',
		ru: 'Страница не может быть загружена!'
	}
	fehler357: any = {
		it: 'Errore 357',
		de: 'Fehler 357',
		deDu: 'Fehler 357',
		en: 'Error 357',
		ru: 'Ошибка 357'
	}
	fehler182: any = {
		it: 'Errore 182',
		de: 'Fehler 182',
		deDu: 'Fehler 182',
		en: 'Error 182',
		ru: 'Ошибка 182'
	}
	keineVersand: any = {
		it: '',
		de: 'Keine Versand-/Abholoptionen verfügbar',
		deDu: 'Keine Versand-/Abholoptionen verfügbar',
		en: 'No shipping/collection options available',
		ru: 'Нет вариантов доставки/самовывоза'
	}
	einstellungen: any = {
		it: 'Impostazioni',
		de: 'Settings',
		deDu: 'Settings',
		en: 'Settings',
		ru: 'Настройки'
	}
	bestellubersicht: any = {
		it: '',
		de: 'Bestellübersicht',
		deDu: 'Bestellübersicht',
		en: 'Order overview',
		ru: 'Обзор заказа'
	}
	imKopf: any = {
		it: 'Nella testa',
		de: 'Im Kopf',
		deDu: 'Im Kopf',
		en: 'In the head',
		ru: 'Вверх'
	}
	inDerFubzeile: any = {
		it: 'Nella piè di pagina',
		de: 'In der Fußzeile',
		deDu: 'In der Fußzeile',
		en: 'In the footer',
		ru: 'Вниз'
	}
	imTab: any = {
		it: '',
		de: 'Im Tab',
		deDu: 'Im Tab',
		en: 'In tab',
		ru: 'В закладки'
	}
	bearbeiten: any = {
		it: 'Modificare',
		de: 'Bearbeiten',
		deDu: 'Bearbeiten',
		en: 'Edit',
		ru: 'Редактировать'
	}
	blocknamenEingeben: any = {
		it: '',
		de: 'Blocknamen eingeben...',
		deDu: 'Blocknamen eingeben...',
		en: 'Enter block name...',
		ru: 'Введите имя блока...'
	}
	pfand: any = {
		it: 'Il pegno',
		de: 'Pfand',
		deDu: 'Pfand',
		en: 'Deposit',
		ru: 'Депозит'
	}
	modalSizeTextS: any = {
		it: '',
		de: 'z.B. ein kleiner Rucksack oder eine Handtasche',
		deDu: 'z.B. ein kleiner Rucksack oder eine Handtasche',
		en: 'e.g. a small backpack or a handbag',
		ru: 'Например небольшой рюкзак или сумочка'
	}
	modalSizeTextM: any = {
		it: '',
		de: 'z.B. ein großer Rucksack',
		deDu: 'z.B. ein großer Rucksack',
		en: 'e.g. a large backpack',
		ru: 'Например большой рюкзак'
	}
	modalSizeTextL: any = {
		it: '',
		de: 'z.B. zwei kleine Reisekoffer',
		deDu: 'z.B. zwei kleine Reisekoffer',
		en: 'e.g. two small suitcases',
		ru: 'Например два маленьких чемодана'
	}
	modalSizeTextXl: any = {
		it: '',
		de: 'z.B. ein großer Reisekoffer',
		deDu: 'z.B. ein großer Reisekoffer',
		en: 'e.g. a large suitcase',
		ru: 'Например большой чемодан'
	}

	// LOCKER PROMO SEARCH

	blockBearbeiten: any = {
		it: 'Modifichi il blocco',
		de: 'Block bearbeiten',
		deDu: 'Block bearbeiten',
		en: 'Edit block',
		ru: 'Редактировать блок'
	}
	blockEinstellungen: any = {
		it: 'Imposti il blocco',
		de: 'Block-Einstellungen',
		deDu: 'Block-Einstellungen',
		en: 'Block-Settings',
		ru: 'Блок-Настройки'
	}
	wieVielZeit: any = {
		it: 'Quanto tempo hai bisogno?',
		de: 'Standort & Mietdauer wählen',
		deDu: 'Standort & Mietdauer wählen',
		en: 'Choose location & rental period',
		ru: 'Выберите место и срок аренды'
	}

	abSofort: any = {
		it: 'Da subito',
		de: 'Ab sofort',
		deDu: 'Ab sofort',
		en: 'From now on',
		ru: 'Немедленно'
	}
	furSpater: any = {
		it: '',
		de: 'Für später reservieren',
		deDu: 'Für später reservieren',
		en: 'Reserve for later',
		ru: 'Зарезервировать на потом'
	}
	suche: any = {
		it: 'Ricerca',
		de: 'Search',
		deDu: 'Search',
		en: 'Search',
		ru: 'Искать'
	}
	suchen: any = {
		it: 'Cercare',
		de: 'Suchen',
		deDu: 'Suchen',
		en: 'Search',
		ru: 'Искать'
	}
	placeholderTitle: any = {
		it: 'Aggiungi un titolo',
		de: 'Titel hinzufügen...',
		deDu: 'Titel hinzufügen...',
		en: 'Enter title ...',
		ru: 'Добавить заголовок...'
	}
	placeholderText: any = {
		it: 'Aggiungi un testo',
		de: 'Text hinzufügen...',
		deDu: 'Text hinzufügen...',
		en: 'Enter text ...',
		ru: 'Добавить текст...'
	}
	placeholderDescription: any = {
		it: 'Aggiungi una descrizione',
		de: 'Beschreibung hinzufügen...',
		deDu: 'Beschreibung hinzufügen...',
		en: 'Enter description ...',
		ru: 'Добавить текст...'
	}
	adresseAuswahlen: any = {
		it: '',
		de: 'Standort auswählen...',
		deDu: 'Standort auswählen...',
		en: 'Choose location ...',
		ru: 'Выберите место...'
	}
	abWannMieten: any = {
		it: '',
		de: 'Ab wann mieten?',
		deDu: 'Ab wann mieten',
		en: 'When to start?',
		ru: 'С какого момента арендовать?'
	}

	// Container Admin Login

	bitteMeldenSie: any = {
		it: 'Accedi da amministartore ',
		de: 'Bitte melden Sie sich als Administrator am System an:',
		deDu: 'Bitte melden Sie sich als Administrator am System an:',
		en: 'Please log in to the system as an administrator:',
		ru: 'Пожалуйста, войдите в систему как администратор:'
	}
	eMailAdresse: any = {
		it: 'L\'indirizzo e-mail',
		de: 'E-Mail Adresse',
		deDu: 'E-Mail Adresse',
		en: 'E-mail address',
		ru: 'E-mail адрес'
	}
	passwort: any = {
		it: 'La password',
		de: 'Passwort',
		deDu: 'Passwort',
		en: 'Password',
		ru: 'Пароль'
	}

	abmelden: any = {
		it: 'Esci',
		de: 'Abmelden',
		deDu: 'Abmelden',
		en: 'Log Out',
		ru: 'Выйти'
	}
	sieSindAls: any = {
		it: 'Sei registrato da ammistratore',
		de: 'Sie sind als Administrator angemeldet:',
		deDu: 'Sie sind als Administrator angemeldet:',
		en: 'You are logged in as an administrator:',
		ru: 'Вы вошли в систему как администратор:'
	}

	// Container BLOG-POSTS

	filter: any = {
		it: 'Filter',
		de: 'Filter',
		deDu: 'Filter',
		en: 'Filter',
		ru: 'Фильтр'
	}
	tags: any = {
		it: 'Tags',
		de: 'Tags:',
		deDu: 'Tags:',
		en: 'Tags:',
		ru: 'Тeги:'
	}
	monate: any = {
		it: 'Mesi',
		de: 'Monate',
		deDu: 'Monate',
		en: 'Months',
		ru: 'Месяцы'
	}
	alle: any = {
		it: 'Tutte',
		de: 'Alle',
		deDu: 'Alle',
		en: 'All',
		ru: 'Все'
	}
	allE: any = {
		it: 'Tutte',
		de: 'Alle',
		deDu: 'Alle',
		en: 'All',
		ru: 'Всем'
	}

	seiteBearbeiten: any = {
		it: 'Modifichi la pagina',
		de: 'Seite bearbeiten',
		deDu: 'Seite bearbeiten',
		en: 'Edit page',
		ru: 'Редактировать страницу'
	}
	SeiteLoschen: any = {
		it: 'Cancelli la pagina',
		de: 'Seite löschen',
		deDu: 'Seite löschen',
		en: 'Delete page',
		ru: 'Удалить страницу'
	}
	artikelHinzufugen: any = {
		it: 'Aggiungi un\'articolo',
		de: 'Artikel hinzufügen',
		deDu: 'Artikel hinzufügen',
		en: 'Add article',
		ru: 'Добавить контент'
	}

	// Container CATEGORIES-GRID
	contact: any = {
		it: 'Contatto',
		de: 'Kontakt',
		deDu: 'Kontakt',
		en: 'Contact',
		ru: 'Запрос'
	}
	categories: any = {
		it: 'Categorie',
		de: 'Kategorien',
		deDu: 'Kategorien',
		en: 'Categories',
		ru: 'Категории'
	}
	closeCategories: any = {
		it: 'Chiudi le categorie',
		de: 'Kategorien schließen',
		deDu: 'Kategorien schließen',
		en: 'Close categories',
		ru: 'Закрыть категории'
	}
	showCategories: any = {
		it: 'Mostra categorie',
		de: 'Kategorien anzeigen',
		deDu: 'Kategorien anzeigen',
		en: 'Show categories',
		ru: 'Показать категории'
	}
	kategorieHinzufugen: any = {
		it: 'Aggiungi una categoria',
		de: 'Kategorie hinzufügen',
		deDu: 'Kategorie hinzufügen',
		en: 'Add Category',
		ru: 'Добавить категорию'
	}
	mobKategorie: any = {
		it: 'Categorie',
		de: 'Kategorie',
		deDu: 'Kategorie',
		en: 'Category',
		ru: 'Категория'
	}
	kategorienEinstellungen: any = {
		it: 'Impostazione delle categorie',
		de: 'Kategorien-Einstellungen',
		deDu: 'Kategorien-Einstellungen',
		en: 'Categories Settings',
		ru: 'Настройки категорий'
	}
	kategoriEinstellungen: any = {
		it: 'Impostazioni',
		de: 'Einstellungen',
		deDu: 'Einstellungen',
		en: 'Settings',
		ru: 'Настройки'
	}
	deineSucheNach: any = {
		it: 'La tua ricerca per:',
		de: 'Deine Suche nach:',
		deDu: 'Deine Suche nach:',
		en: 'Your search for:',
		ru: 'Ваш поиск:'
	}
	zuruckZuDen: any = {
		it: 'Indietro alle',
		de: 'Zurück zu den',
		deDu: 'Zurück zu den',
		en: 'Back to the',
		ru: 'Назад к'
	}
	kategorien: any = {
		it: 'Categorie',
		de: 'Kategorien',
		deDu: 'Kategorien',
		en: 'Categories',
		ru: 'Категории'
	}
	artikel: any = {
		it: 'Articolo',
		de: 'Artikel',
		deDu: 'Artikel',
		en: 'Article',
		ru: 'Контент'
	}
	seite: any = {
		it: 'Pagina',
		de: 'Location',
		deDu: 'Location',
		en: 'Location',
		ru: 'Страница'
	}
	von: any = {
		it: 'da',
		de: 'von',
		deDu: 'von',
		en: 'of',
		ru: 'из'
	}
	weiterenArtikelHinzufugen: any = {
		it: 'Aggiungi un\'altro articolo',
		de: 'Weiteren Artikel hinzufügen',
		deDu: 'Weiteren Artikel hinzufügen',
		en: 'Add another article',
		ru: 'Добавить ещё контент'
	}
	zurArtikelsuche: any = {
		it: 'Vai alla ricerca degli articoli',
		de: 'Zur Artikelsuche',
		deDu: 'Zur Artikelsuche',
		en: 'To the article search',
		ru: 'К поиску товаров'
	}
	nichtFundigGeworden: any = {
		it: 'Non hai trovato niente? Prova la nostra ricerca',
		de: 'Nicht fündig geworden? Probier unsere Suche aus.',
		deDu: 'Nicht fündig geworden? Probier unsere Suche aus.',
		en: "Didn't find what you were looking for? Try our search.",
		ru: 'Не нашли то, что искали? Воспользуйтесь нашим поиском.'
	}

	// Container CONTACT-FORM

	senden: any = {
		it: 'Invii',
		de: 'Senden',
		deDu: 'Senden',
		en: 'Send',
		ru: 'Отправить'
	}

	// Container CONTRACT

	angebot: any = {
		it: 'L\'offerta',
		de: 'Angebot',
		deDu: 'Angebot',
		en: 'Offer',
		ru: 'Предложение'
	}
	zahlungsbedingungen: any = {
		it: 'Condizioni di pagamento',
		de: 'Zahlungsbedingungen',
		deDu: 'Zahlungsbedingungen',
		en: 'Terms of payment',
		ru: 'Условия платежа'
	}
	signatur: any = {
		it: 'Firma digitale',
		de: 'Signatur',
		deDu: 'Signatur',
		en: 'Signature',
		ru: 'Подпись'
	}
	unterschrift: any = {
		it: 'Firma',
		de: 'Unterschrift',
		deDu: 'Unterschrift',
		en: 'Signature',
		ru: 'Подпись'
	}
	widerrufsrechts: any = {
		it: 'Diritto di rivoca',
		de: 'Widerrufsrechts',
		deDu: 'Widerrufsrechts',
		en: 'Right of withdrawal',
		ru: 'Право на отзыв'
	}
	aGB: any = {
		it: 'Condizioni di vendita',
		de: 'AGB',
		deDu: 'AGB',
		en: 'GTC',
		ru: 'ОПУ'
	}
	interaktiveElemente: any = {
		it: 'Elementi interattivi',
		de: 'Interaktive Elemente',
		deDu: 'Interaktive Elemente',
		en: 'Interactive elements',
		ru: 'Интерактивные элементы'
	}
	adminBearbeitung: any = {
		it: 'Admin/impostazionoi',
		de: 'Admin / Bearbeitung',
		deDu: 'Admin / Bearbeitung',
		en: 'Admin / Editing',
		ru: 'Админ / Редактирование'
	}
	auftrag: any = {
		it: 'L\'ordine',
		de: 'Auftrag',
		deDu: 'Auftrag',
		en: 'Order',
		ru: 'Заказ'
	}
	ihrAnsprechpartner: any = {
		it: 'Persona di riferimento',
		de: 'Ihr Ansprechpartner:',
		deDu: 'Ihr Ansprechpartner:',
		en: 'Your contact person',
		ru: 'Ваши контакты'
	}
	telefon: any = {
		it: 'Telefono',
		de: 'Telefon:',
		deDu: 'Telefon:',
		en: 'Phone:',
		ru: 'Телефон:'
	}
	mobil: any = {
		it: 'Cellulare',
		de: 'Mobile number:',
		deDu: 'Mobile number:',
		en: 'Mobile:',
		ru: 'Мобильный:',
	}
	fax: any = {
		it: 'Fax',
		de: 'Fax:',
		deDu: 'Fax:',
		en: 'Fax:',
		ru: 'Факс:'
	}
	eMail: any = {
		it: 'Email',
		de: 'E-Mail:',
		deDu: 'E-Mail:',
		en: 'E-Mail:',
		ru: 'Эл. адрес:'
	}
	email: any = {
		it: 'Email',
		de: 'E-Mail',
		deDu: 'E-Mail',
		en: 'E-Mail',
		ru: 'Эл. адрес'
	}
	nachname: any = {
		it: 'Cognome',
		de: 'Surname',
		deDu: 'Surname',
		en: 'Last name',
		ru: 'Фамилия'
	}
	vorname: any = {
		it: 'Nome',
		de: 'Given name',
		deDu: 'Given name',
		en: 'First name',
		ru: 'Имя'
	}
	sNr: any = {
		it: 's no.:',
		de: 's-Nr.:',
		deDu: 's-Nr.:',
		en: 's no.:',
		ru: 'с №:'
	}
	datum: any = {
		it: 'Data',
		de: 'Date',
		deDu: 'Date',
		en: 'Date',
		ru: 'Дата'
	}
	blockHinzufugen: any = {
		it: 'Aggiungere un blocco',
		de: 'Block hinzufügen',
		deDu: 'Block hinzufügen',
		en: 'Add block',
		ru: 'Добавить блок'
	}
	gesamtsumme: any = {
		it: 'Somma totale',
		de: 'Gesamtsumme',
		deDu: 'Gesamtsumme',
		en: 'Total',
		ru: 'Всего'
	}
	darinEnthalteMwSt: any = {
		it: 'compreso IVA ',
		de: 'darin enthalte MwSt.',
		deDu: 'darin enthalte MwSt.',
		en: 'it includes VAT',
		ru: 'включает НДС'
	}
	werdenInnerhalb: any = {
		it: '',
		de: '5.000,00 € werden innerhalb von 14 Tagen nach Erhalt der Bestellbestätigung bezahlt. Mit der Bestellbestätigung erhalten Sie unsere Bankverbindung. Sie erhalten die Bestellbestätigung sechs Wochen nach Vertragsunterzeichnung.',
		deDu: '5.000,00 € werden innerhalb von 14 Tagen nach Erhalt der Bestellbestätigung bezahlt. Mit der Bestellbestätigung erhalten Sie unsere Bankverbindung. Sie erhalten die Bestellbestätigung sechs Wochen nach Vertragsunterzeichnung.',
		en: '€5,000.00 will be paid within 14 days of receipt of the order confirmation. You will receive our bank details with the order confirmation. You will receive the order confirmation six weeks after signing the contract.',
		ru: '€5,000.00 будут выплачены в течение 14 дней с момента получения подтверждения заказа. Вы получите наши банковские реквизиты с подтверждением заказа. Вы получите подтверждение заказа через шесть недель после подписания договора.'
	}
	bemerkungen: any = {
		it: 'Notizie',
		de: 'Bemerkungen:',
		deDu: 'Bemerkungen:',
		en: 'Remarks:',
		ru: 'Примечания:'
	}
	OrtDatum: any = {
		it: 'Luogo, data',
		de: 'Ort, Datum',
		deDu: 'Ort, Datum',
		en: 'Place, date',
		ru: 'Место, дата'
	}
	unterschriftDes: any = {
		it: 'Firma del compratore',
		de: 'Unterschrift des Käufers',
		deDu: 'Unterschrift des Käufers',
		en: 'Signature of the buyer',
		ru: 'Подпись покупателя'
	}
	allgemeine: any = {
		it: 'Condizioni di vendita compresi',
		de: 'Allgemeine Geschäftsbedingungen erhalten',
		deDu: 'Allgemeine Geschäftsbedingungen erhalten',
		en: 'Receive Terms and Conditions',
		ru: 'Получить условия'
	}
	neuwagen: any = {
		it: '',
		de: 'Neuwagen-Verkaufsbedingungen',
		deDu: 'Neuwagen-Verkaufsbedingungen',
		en: 'New Vehicle Terms of Sale',
		ru: 'Условия продажи нового автомобиля'
	}
	kraftfahrzeuge: any = {
		it: '',
		de: 'Kraftfahrzeuge und Anhänger',
		deDu: 'Kraftfahrzeuge und Anhänger',
		en: 'Motor vehicles and trailers',
		ru: 'Автомобили и прицепы'
	}
	geschaftsfuhrer: any = {
		it: 'Responsabile',
		de: 'Geschäftsführer:',
		deDu: 'Geschäftsführer:',
		en: 'Managing Director:',
		ru: 'Управляющий:'
	}
	kontoNr: any = {
		it: 'Numero conto',
		de: 'Konto-Nr.',
		deDu: 'Konto-Nr.',
		en: 'Account no.',
		ru: 'Номер счёта'
	}
	blockTyp: any = {
		it: 'Scegli il tipo di blocco',
		de: 'Block Typ wählen',
		deDu: 'Block Typ wählen',
		en: 'Choose block type',
		ru: 'Выбрать тип блока'
	}

	// Container CRM

	optionHinzufugen: any = {
		it: 'Aggiungi un\'opzione',
		de: 'Option hinzufügen',
		deDu: 'Option hinzufügen',
		en: 'Add option',
		ru: 'Добавить опцию'
	}

	// Container FAQ

	hierFindestDu: any = {
		it: '',
		de: 'Hier findest du häufig gestellte Fragen und Antworten über uns und unsere Dienstleistungen.',
		deDu: 'Hier findest du häufig gestellte Fragen und Antworten über uns und unsere Dienstleistungen.',
		en: 'Here you will find frequently asked questions and answers about us and our services.',
		ru: 'Здесь вы найдете часто задаваемые вопросы и ответы о нас и наших услугах.'
	}

	// Container ICON-CARDS

	weitereAngebote: any = {
		it: 'Mostri altre offerte',
		de: 'weitere Angebote anzeigen',
		deDu: 'weitere Angebote anzeigen',
		en: 'show more offers',
		ru: 'показать больше предложений'
	}

	// Container IMG-BOX

	uberschriftHinzufugen: any = {
		it: '',
		de: 'Überschrift hinzufügen...',
		deDu: 'Überschrift hinzufügen...',
		en: 'Add heading...',
		ru: 'Добавить название...'
	}
	titelHinzufugen: any = {
		it: '',
		de: 'Titel hinzufügen...',
		deDu: 'Titel hinzufügen...',
		en: 'Add title...',
		ru: 'Добавить заголовок...'
	}
	textHinzufugen: any = {
		it: '',
		de: 'Text hinzufügen...',
		deDu: 'Text hinzufügen...',
		en: 'Add text...',
		ru: 'Добавить текст...'
	}
	tagsHinzufugen: any = {
		it: '',
		de: 'Tags hinzufügen...',
		deDu: 'Tags hinzufügen...',
		en: 'Add tags...',
		ru: 'Добавить теги...'
	}

	// Container ITEMS-ROW

	// Container MENU-HORIZONTAL

	neu: any = {
		it: 'nuovo',
		de: 'neu',
		deDu: 'neu',
		en: 'new',
		ru: 'новый'
	}

	// Container MY-COUPONS

	aktuelleAktionen: any = {
		it: '',
		de: 'Aktuelle Aktionen / Gutscheine',
		deDu: 'Aktuelle Aktionen / Gutscheine',
		en: 'Current promotions / vouchers',
		ru: 'Текущие акции / ваучеры'
	}
	duKannst: any = {
		it: '',
		de: 'Du kannst einen Gutschein aktivieren, in dem du ihn in folgender Liste auswählst:',
		deDu: 'Du kannst einen Gutschein aktivieren, in dem du ihn in folgender Liste auswählst:',
		en: 'You can activate a voucher by selecting it from the following list:',
		ru: 'Вы можете активировать ваучер, выбрав его из следующего списка:'
	}
	schwarzerFreitag: any = {
		it: '',
		de: 'Schwarzer Freitag',
		deDu: 'Schwarzer Freitag',
		en: 'Black Friday',
		ru: 'Черная пятница'
	}
	subigkeiten: any = {
		it: '',
		de: 'Süßigkeiten',
		deDu: 'Süßigkeiten',
		en: 'Sweets',
		ru: 'Сладости'
	}
	aktivieren: any = {
		it: '',
		de: 'aktivieren',
		deDu: 'aktivieren',
		en: 'activate',
		ru: 'активировать'
	}
	gultig: any = {
		it: '',
		de: 'Gültig',
		deDu: 'Gültig',
		en: 'Valid',
		ru: 'Активирован'
	}
	uhr: any = {
		it: '',
		de: 'Uhr',
		deDu: 'Uhr',
		en: 'Hour',
		ru: 'Час'
	}
	min: any = {
		it: '',
		de: 'Min',
		deDu: 'Min',
		en: 'Min',
		ru: 'Мин'
	}
	sek: any = {
		it: '',
		de: 'Sek',
		deDu: 'Sek',
		en: 'Sec',
		ru: 'Сек'
	}
	jetztEinkaufen: any = {
		it: '',
		de: 'Jetzt einkaufen',
		deDu: 'Jetzt einkaufen',
		en: 'Shopping now',
		ru: 'Купить сейчас'
	}
	heuteGibt: any = {
		it: '',
		de: 'Heute gibt es leider keine Aktionen',
		deDu: 'Heute gibt es leider keine Aktionen',
		en: 'Unfortunately there are no promotions today',
		ru: 'К сожалению, сегодня нет акций'
	}
	versuche: any = {
		it: '',
		de: 'Versuche es ein anderes Mal wieder.',
		deDu: 'Versuche es ein anderes Mal wieder.',
		en: 'Try again another time.',
		ru: 'Попробуйте еще раз.'
	}

	// Container NEWSLETTER-HEADER


	// Container PROMO


	// Container SCREENSHOT-BOX


	// Container SETTINGS

	aufStandard: any = {
		it: '',
		de: 'Standard',
		deDu: 'Standard',
		en: 'Default',
		ru: 'По умолчанию'
	}
	adresse: any = {
		it: '',
		de: 'Adresse',
		deDu: 'Adresse',
		en: 'Address',
		ru: 'Адрес'
	}
	phone: any = {
		it: '',
		de: 'Phone',
		deDu: 'Phone',
		en: 'Phone',
		ru: 'Телефон'
	}
	weitererZeitraum: any = {
		it: '',
		de: 'Weiterer Zeitraum',
		deDu: 'Weiterer Zeitraum',
		en: 'Additional period',
		ru: 'Дополнительный период'
	}
	artikelgruppe: any = {
		it: '',
		de: 'Artikelgruppe',
		deDu: 'Artikelgruppe',
		en: 'Article group',
		ru: 'Группа товаров'
	}
	aktiviert: any = {
		it: '',
		de: 'aktiviert',
		deDu: 'aktiviert',
		en: 'activated',
		ru: 'активирован'
	}
	deaktiviert: any = {
		it: '',
		de: 'deaktiviert',
		deDu: 'deaktiviert',
		en: 'disabled',
		ru: 'отключен'
	}
	schritte: any = {
		it: '',
		de: 'Schritte:',
		deDu: 'Schritte:',
		en: 'Steps:',
		ru: 'Шаги:'
	}
	menge: any = {
		it: '',
		de: 'Menge:',
		deDu: 'Menge:',
		en: 'Amount:',
		ru: 'Количество:'
	}
	gutschein: any = {
		it: '',
		de: 'Gutschein',
		deDu: 'Gutschein',
		en: 'Voucher',
		ru: 'Чек'
	}
	erstelltAm: any = {
		it: '',
		de: 'erstellt am:',
		deDu: 'erstellt am:',
		en: 'created on:',
		ru: 'создано на:'
	}
	default: any = {
		it: '',
		de: 'Default',
		deDu: 'Default',
		en: 'Default',
		ru: 'По-умолчанию'
	}
	Grundlegendes: any = {
		it: '',
		de: 'Grundlegendes',
		deDu: 'Grundlegendes',
		en: 'Basic',
		ru: 'Основные'
	}
	'Lokale Einstellungen': any = {
		it: '',
		de: 'Lokale Einstellungen',
		deDu: 'Lokale Einstellungen',
		en: 'Local Settings',
		ru: 'Локальные настройки'
	}
	'Preise & Gutscheine': any = {
		it: '',
		de: 'Preise & Gutscheine',
		deDu: 'Preise & Gutscheine',
		en: 'Prices and Coupons',
		ru: 'Цены и купоны'
	}
	'Öffnungszeiten': any = {
		it: '',
		de: 'Opening hours',
		deDu: 'Opening hours',
		en: 'Opening hours',
		ru: 'Время работы'
	}
	'Artikelgruppen': any = {
		it: '',
		de: 'Artikelgruppen',
		deDu: 'Artikelgruppen',
		en: 'Item groups',
		ru: 'Группы товаров'
	}
	'Restartikel': any = {
		it: '',
		de: 'Restartikel',
		deDu: 'Restartikel',
		en: 'Rest settings',
		ru: 'Остальные настройки'
	}
	'Sonderöffnungszeiten': any = {
		it: '',
		de: 'Special opening hours',
		deDu: 'Special opening hours',
		en: 'Special opening times',
		ru: 'Особое время работы'
	}
	'Versandoptionen': any = {
		it: '',
		de: 'Versandoptionen',
		deDu: 'Versandoptionen',
		en: 'Shipping options',
		ru: 'Варианты доставки'
	}
	'Zahlungsoptionen': any = {
		it: '',
		de: 'Zahlungsoptionen',
		deDu: 'Zahlungsoptionen',
		en: 'Payment options',
		ru: 'Варианты оплаты'
	}
	'Gutscheine': any = {
		it: '',
		de: 'Gutscheine',
		deDu: 'Gutscheine',
		en: 'Coupons',
		ru: 'Купоны'
	}
	//settings translate
	'Sprachen': any = {
		it: '',
		de: 'Sprachen',
		deDu: 'Sprachen',
		en: 'Languages',
		ru: 'Языки'
	}
	'Aktivieren Sie bestimmte Sprachdateien für Ihre Website': any = {
		it: '',
		de: 'Aktivieren Sie bestimmte Sprachdateien für Ihre Website',
		deDu: 'Aktivieren Sie bestimmte Sprachdateien für Ihre Website',
		en: 'Activate specific language files for your website',
		ru: 'Активируйте определённые языковые файлы для вашего сайта'
	}
	'Seitenname': any = {
		it: '',
		de: 'Seitenname',
		deDu: 'Seitenname',
		en: 'Site name',
		ru: 'Название сайта'
	}
	'Name in Kopfzeile': any = {
		it: '',
		de: 'Name in Kopfzeile',
		deDu: 'Name in Kopfzeile',
		en: 'Name in header',
		ru: 'Название в заголовке'
	}
	'Absender E-Mail Adresse': any = {
		it: '',
		de: 'Absender E-Mail Adresse',
		deDu: 'Absender E-Mail Adresse',
		en: 'Sender email address',
		ru: 'Адрес электронной почты отправителя'
	}
	'für Systemnachrichten': any = {
		it: '',
		de: 'für Systemnachrichten',
		deDu: 'für Systemnachrichten',
		en: 'for system messages',
		ru: 'для системных сообщений'
	}
	'Absender E-Mail Name': any = {
		it: '',
		de: 'Absender E-Mail Name',
		deDu: 'Absender E-Mail Name',
		en: 'Sender email name',
		ru: 'Имя отправителя электронной почты'
	}
	'Admin E-Mail': any = {
		it: '',
		de: 'Admin E-Mail',
		deDu: 'Admin E-Mail',
		en: 'Admin email',
		ru: 'Электронная почта администратора'
	}
	'Empfänger aller Systemnachrichten': any = {
		it: '',
		de: 'Empfänger aller Systemnachrichten',
		deDu: 'Empfänger aller Systemnachrichten',
		en: 'Recipient of all system messages',
		ru: 'Получатель всех системных сообщений'
	}
	'Geschäftsadresse': any = {
		it: '',
		de: 'Geschäftsadresse',
		deDu: 'Geschäftsadresse',
		en: 'Business address',
		ru: 'Адрес компании'
	}
	'Straße, Hausnummer, PLZ, Ort': any = {
		it: '',
		de: 'Straße, Hausnummer, PLZ, Ort',
		deDu: 'Straße, Hausnummer, PLZ, Ort',
		en: 'Languages',
		ru: 'Улица, Номер дома, Почтовый индекс, Город'
	}
	'E-Mail für Kontaktanfragen': any = {
		it: '',
		de: 'E-Mail für Kontaktanfragen',
		deDu: 'E-Mail für Kontaktanfragen',
		en: 'Email for contact requests',
		ru: 'Электронная почта для запросов контактов'
	}
	'Telefon-Nr. für Kontaktanfragen': any = {
		it: '',
		de: 'Telefon-Nr. für Kontaktanfragen',
		deDu: 'Telefon-Nr. für Kontaktanfragen',
		en: 'Phone number. for contact requests',
		ru: 'Номер телефона. для запросов контактов'
	}
	'WhatsApp-Nr. für Kontaktanfragen': any = {
		it: '',
		de: 'WhatsApp-Nr. für Kontaktanfragen',
		deDu: 'WhatsApp-Nr. für Kontaktanfragen',
		en: 'WhatsApp no. for contact requests',
		ru: 'Номер ватсап для запросов контактов'
	}
	'Designvorlage': any = {
		it: '',
		de: 'Designvorlage',
		deDu: 'Designvorlage',
		en: 'Design Template',
		ru: 'Шаблон дизайна'
	}
	'white-clean oder black-clean': any = {
		it: '',
		de: 'white-clean oder black-clean',
		deDu: 'white-clean oder black-clean',
		en: 'white-clean or black-clean',
		ru: 'белый-чистый или черный-чистый'
	}
	'Standard Ansicht für Kategorie': any = {
		it: '',
		de: 'Standard Ansicht für Kategorie',
		deDu: 'Standard Ansicht für Kategorie',
		en: 'Default view for category',
		ru: 'Стандартный вид для категории'
	}
	'Standard Ansicht für Artikel': any = {
		it: '',
		de: 'Standard Ansicht für Artikel',
		deDu: 'Standard Ansicht für Artikel',
		en: 'Standard view for articles',
		ru: 'Стандартный вид для статей'
	}
	'Logo': any = {
		it: '',
		de: 'Logo',
		deDu: 'Logo',
		en: 'Logo',
		ru: 'Логотип'
	}
	'Seiten Menü aktiv?': any = {
		it: '',
		de: 'Seiten Menü aktiv?',
		deDu: 'Seiten Menü aktiv?',
		en: 'Side menu active?',
		ru: 'Боковое меню активировано?'
	}
	'Katalogmodus aktiv?': any = {
		it: '',
		de: 'Katalogmodus aktiv?',
		deDu: 'Katalogmodus aktiv?',
		en: 'Catalog mode active?',
		ru: 'Режим каталога активирован?'
	}
	'Preise & Warenkorb werden ausgeblendet': any = {
		it: '',
		de: 'Preise & Warenkorb werden ausgeblendet',
		deDu: 'Preise & Warenkorb werden ausgeblendet',
		en: 'Prices & shopping cart are hidden',
		ru: 'Цены и корзина скрыты'
	}
	'Shop-Suche aktiv?': any = {
		it: '',
		de: 'Shop-Suche aktiv?',
		deDu: 'Shop-Suche aktiv?',
		en: 'Shop search active?',
		ru: 'Поиск по магазину активен?'
	}
	'in Desktopansicht': any = {
		it: '',
		de: 'in Desktopansicht',
		deDu: 'in Desktopansicht',
		en: 'in desktop view',
		ru: 'в компютерной версии'
	}
	'Shop-Suche mobile aktiv?': any = {
		it: '',
		de: 'Shop-Suche mobile aktiv?',
		deDu: 'Shop-Suche mobile aktiv?',
		en: 'Mobile shop search active?',
		ru: 'Поиск по магазину на мобильной версии активен?'
	}
	'in Mobilansicht': any = {
		it: '',
		de: 'in Mobilansicht',
		deDu: 'in Mobilansicht',
		en: 'in mobile view',
		ru: 'в мобильной версии'
	}
	'Shop show menu filter?': any = {
		it: '',
		de: 'Menüfilter für Shop anzeigen?',
		deDu: 'Menüfilter für Shop anzeigen?',
		en: 'Shop show menu filter?',
		ru: 'Показать фильтр меню магазина?'
	}
	'E-Mail aktiv?': any = {
		it: '',
		de: 'E-Mail aktiv?',
		deDu: 'E-Mail aktiv?',
		en: 'Email active?',
		ru: 'Электронная почта активна?'
	}
	'z.B. für digitale Gutscheine': any = {
		it: '',
		de: 'z.B. für digitale Gutscheine',
		deDu: 'z.B. für digitale Gutscheine',
		en: 'e.G. for digital coupons',
		ru: 'например, для цифровых купонов'
	}
	'Postversand aktiv?': any = {
		it: '',
		de: 'Postversand aktiv?',
		deDu: 'Postversand aktiv?',
		en: 'Mail delivery active?',
		ru: 'Доставка почтой активна?'
	}
	'z.B. per DHL, Hermes usw.': any = {
		it: '',
		de: 'z.B. per DHL, Hermes usw.',
		deDu: 'z.B. per DHL, Hermes usw.',
		en: 'e.G. by DHL, Hermes etc.',
		ru: 'например, DHL, Hermes и т.д.'
	}
	'Lieferung aktiv?': any = {
		it: '',
		de: 'Lieferung aktiv?',
		deDu: 'Lieferung aktiv?',
		en: 'Delivery active?',
		ru: 'Доставка активна?'
	}
	'z.B. eigener Lieferservice': any = {
		it: '',
		de: 'z.B. eigener Lieferservice',
		deDu: 'z.B. eigener Lieferservice',
		en: 'e.G. own delivery service',
		ru: 'например, собственная служба доставки'
	}
	'Selbstabholung aktiv?': any = {
		it: '',
		de: 'Selbstabholung aktiv?',
		deDu: 'Selbstabholung aktiv?',
		en: 'Self collection active?',
		ru: 'Самовывоз активен?'
	}
	'z.B. für Restaurants': any = {
		it: '',
		de: 'z.B. für Restaurants',
		deDu: 'z.B. für Restaurants',
		en: 'e.G. for restaurants',
		ru: 'например, для ресторанов'
	}
	'Shop menu enabled?': any = {
		it: '',
		de: 'Shop-Menü aktiviert?',
		deDu: 'Shop-Menü aktiviert?',
		en: 'Shop menu enabled?',
		ru: 'Меню магазина включено?'
	}
	'Fußzeile deaktiviert?': any = {
		it: '',
		de: 'Fußzeile deaktiviert?',
		deDu: 'Fußzeile deaktiviert?',
		en: 'Footer disabled?',
		ru: 'Нижний блок отключен?'
	}
	'Block unten auf der Seite': any = {
		it: '',
		de: 'Block unten auf der Seite',
		deDu: 'Block unten auf der Seite',
		en: 'Block at the bottom of the page',
		ru: 'Блок внизу страницы'
	}
	'Bestellung Liefer Mindestwert': any = {
		it: '',
		de: 'Bestellung Liefer Mindestwert',
		deDu: 'Bestellung Liefer Mindestwert',
		en: 'Order delivery minimum value',
		ru: 'Минимальная стоимость доставки заказа'
	}
	'Vorbereitungszeit bestellen': any = {
		it: '',
		de: 'Vorbereitungszeit bestellen',
		deDu: 'Vorbereitungszeit bestellen',
		en: 'Order preparation time',
		ru: 'Время приготовления заказа'
	}
	'Rasterelemente pro Seite': any = {
		it: '',
		de: 'Rasterelemente pro Seite',
		deDu: 'Rasterelemente pro Seite',
		en: 'Grid items per page',
		ru: 'Элементов сетки на странице'
	}
	// 'Sprachen': any = {
	// 	it: '',
	// 	de: 'Sprachen',
	// 	deDu: 'Sprachen',
	// 	en: 'Languages',
	// 	ru: 'Языки'
	// }
	// 'Sprachen': any = {
	// 	it: '',
	// 	de: 'Sprachen',
	// 	deDu: 'Sprachen',
	// 	en: 'Languages',
	// 	ru: 'Языки'
	// }

	sonderoffnungszeitenHinzufugen: any = {
		it: '',
		de: 'Sonderöffnungszeiten hinzufügen',
		deDu: 'Sonderöffnungszeiten hinzufügen',
		en: 'Add special opening hours',
		ru: 'Добавьте особые часы работы'
	}

	standardspracheAuswahlen: any = {
		it: '',
		de: 'Standardsprache auswählen',
		deDu: 'Standardsprache auswählen',
		en: 'Select default language',
		ru: 'Выбрать стандартный язык'
	}

	// Container SETUP-SITE

	sieMochten: any = {
		it: '',
		de: 'Sie möchten die eigene Domain verbinden? Hier klicken...',
		deDu: 'Sie möchten die eigene Domain verbinden? Hier klicken...',
		en: 'Would you like to connect your own domain? Click here...',
		ru: 'Хотите подключить свой домен? Кликните сюда...'
	}
	eigeneDomain: any = {
		it: '',
		de: 'Eigene Domain doch lieber später mitteilen? Hier klicken...',
		deDu: 'Eigene Domain doch lieber später mitteilen? Hier klicken...',
		en: 'Prefer to tell us your own domain later? Click here...',
		ru: 'Предпочитаете сообщить нам свой собственный домен позже? Кликните сюда...'
	}
	undSchon: any = {
		it: '',
		de: '...und schon kann es losgehen',
		deDu: '...und schon kann es losgehen',
		en: "...and you're ready to go",
		ru: '...и вы готовы идти'
	}
	hierFinden: any = {
		it: '',
		de: 'Hier finden Sie Ihren neuen Shop.',
		deDu: 'Hier finden Sie Ihren neuen Shop.',
		en: 'You can find your new shop here.',
		ru: 'Вы можете найти свой новый магазин здесь.'
	}
	inhalte: any = {
		it: '',
		de: 'Inhalte hinzufügen &amp; ändern',
		deDu: 'Inhalte hinzufügen &amp; ändern',
		en: 'Add content &amp; change',
		ru: 'Добавить изменение &amp; содержимого'
	}
	hereYouCan: any = {
		it: '',
		de: 'Here you can create new content yourself or change existing content.',
		deDu: 'Here you can create new content yourself or change existing content.',
		en: 'Here you can create new content yourself or change existing content.',
		ru: 'Здесь вы можете сами создавать новый контент или изменять существующий.'
	}
	ihreNeuen: any = {
		it: '',
		de: 'Ihre neuen Zugangsdaten erhalten Sie per E-Mail.',
		deDu: 'Ihre neuen Zugangsdaten erhalten Sie per E-Mail.',
		en: 'You will receive your new access data by email.',
		ru: 'Вы получите новые данные доступа по электронной почте.'
	}

	// Container SLIDESHOW

	sliderEinstellungen: any = {
		it: '',
		de: 'Slider-Einstellungen',
		deDu: 'Slider-Einstellungen',
		en: 'Slider-Settings',
		ru: 'Настройки слайдера'
	}
	slideHinzufugen: any = {
		it: '',
		de: 'Slide hinzufügen',
		deDu: 'Slide hinzufügen',
		en: 'Add slide',
		ru: 'Добавить слайд'
	}
	runter: any = {
		it: '',
		de: 'runter scrollen',
		deDu: 'runter scrollen',
		en: 'scroll down',
		ru: 'прокрутить вниз'
	}

	// Container SLIDESHOW-TWO

	slideshowSlider: any = {
		it: '',
		de: 'Slide',
		deDu: 'Slide',
		en: 'Slide',
		ru: 'Слайд'
	}
	slideshowEinstellungen: any = {
		it: '',
		de: 'Einstellungen',
		deDu: 'Einstellungen',
		en: 'Settings',
		ru: 'Настройки'
	}

	// Container TABLE

	paramaterHinzufugen: any = {
		it: '',
		de: 'Paramater hinzufügen',
		deDu: 'Paramater hinzufügen',
		en: 'Add parameters',
		ru: 'Добавить параметры'
	}

	liefergebiete: any = {
		it: '',
		de: 'Liefergebiete',
		deDu: 'Liefergebiete',
		en: 'Delivery areas',
		ru: 'Районы доставки'
	}
	eingabeDer: any = {
		it: '',
		de: 'Eingabe der Preise <strong>NUR mit Punkt</strong> und <strong>ohne Eurozeichen</strong> wie z.B. <strong>1.99</strong>.',
		deDu: 'Eingabe der Preise <strong>NUR mit Punkt</strong> und <strong>ohne Eurozeichen</strong> wie z.B. <strong>1.99</strong>.',
		en: 'Enter the prices <strong>ONLY with a dot</strong> and <strong>without the euro sign</strong> such as <strong>1.99</strong>.',
		ru: 'Введите цены <strong>ТОЛЬКО с точкой</strong> и <strong>без знака евро</strong>, например <strong>1,99</strong>.'
	}
	cRM: any = {
		it: '',
		de: 'CRM Einstellungen',
		deDu: 'CRM Einstellungen',
		en: 'CRM settings',
		ru: 'CRM настройки'
	}
	parameter: any = {
		it: '',
		de: 'Parameter',
		deDu: 'Parameter',
		en: 'Parameter',
		ru: 'Параметр'
	}
	wert: any = {
		it: '',
		de: 'Wert',
		deDu: 'Wert',
		en: 'Value',
		ru: 'Значение'
	}
	pLZ: any = {
		it: '',
		de: 'PLZ',
		deDu: 'PLZ',
		en: 'Postcode',
		ru: 'Почтовый индекс'
	}
	name: any = {
		it: '',
		de: 'Name',
		deDu: 'Name',
		en: 'Name',
		ru: 'Имя'
	}
	Name: any = {
		it: '',
		de: 'Name',
		deDu: 'Name',
		en: 'Name',
		ru: 'Имя'
	}
	lieferpreis: any = {
		it: '',
		de: 'Lieferpreis',
		deDu: 'Lieferpreis',
		en: 'Delivery price',
		ru: 'Цена доставки'
	}
	minBestWert: any = {
		it: '',
		de: 'Min. Best. Wert',
		deDu: 'Min. Best. Wert',
		en: 'Min Order Value',
		ru: 'Мин. стоимость заказа'
	}

	// Container TEXT-BOX

	// Container YOUTUBE-BLOCK

	// Components BASKET-ITEM-LIST

	artikelliste: any = {
		it: '',
		de: 'Artikelliste',
		deDu: 'Artikelliste',
		en: 'Item list',
		ru: 'Список товаров'
	}
	extras: any = {
		it: '',
		de: 'Extras:',
		deDu: 'Extras:',
		en: 'Extras:',
		ru: 'Дополнительно:'
	}
	artikelEntfernen: any = {
		it: '',
		de: 'Artikel entfernen',
		deDu: 'Artikel entfernen',
		en: 'Remove article',
		ru: 'Удалить контент'
	}
	expertenModusAktivieren: any = {
		it: '',
		de: 'Experten-Modus aktivieren',
		deDu: 'Experten-Modus aktivieren',
		en: 'Activate expert mode',
		ru: 'Активировать экспертный режим'
	}
	expertenModus: any = {
		it: '',
		de: 'Experten-Modus aktivieren',
		deDu: 'Experten-Modus',
		en: 'Expert-Mode',
		ru: 'Эксперт-Режим'
	}
	uberschrift: any = {
		it: '',
		de: 'Überschrift',
		deDu: 'Überschrift',
		en: 'Headline',
		ru: 'Заголовок'
	}
	uberschriftAnzeigen: any = {
		it: '',
		de: 'Überschrift anzeigen',
		deDu: 'Überschrift anzeigen',
		en: 'Show Headline',
		ru: 'Показать заголовок'
	}
	bildVerhaltnis: any = {
		it: '',
		de: 'Bild Verhältnis',
		deDu: 'Bild Verhältnis',
		en: 'Image ratio',
		ru: 'Размер изображения'
	}
	breiteDesInhalts: any = {
		it: '',
		de: 'Breite des Inhalts',
		deDu: 'Breite des Inhalts',
		en: 'Content width',
		ru: 'Ширина контента'
	}
	manKannDen: any = {
		it: '',
		de: 'Man kann den Inhalt auf eine feste Breite begrenzen oder über die volle Breite anzeigen lassen.',
		deDu: 'Man kann den Inhalt auf eine feste Breite begrenzen oder über die volle Breite anzeigen lassen.',
		en: 'You can limit the content to a fixed width or display it over the full width.',
		ru: 'Вы можете ограничить содержимое фиксированной шириной или отобразить его на всю ширину.'
	}
	volleBreiteAktiv: any = {
		it: '',
		de: 'Volle Breite aktiv?',
		deDu: 'Volle Breite aktiv?',
		en: 'Full width active?',
		ru: 'Активировать максимальную ширину?'
	}
	trennung: any = {
		it: '',
		de: 'Trennung',
		deDu: 'Trennung',
		en: 'Separation',
		ru: 'Разделение'
	}
	zurucksetzen: any = {
		it: '',
		de: 'zurücksetzen',
		deDu: 'zurücksetzen',
		en: 'Reset to default',
		ru: 'Восстановить значение по умолчанию'
	}
	manKannEinen: any = {
		it: '',
		de: 'Man kann einen sichtbaren Rahmen ober- und unterhalb des Blocks einblenden.',
		deDu: 'Man kann einen sichtbaren Rahmen ober- und unterhalb des Blocks einblenden.',
		en: 'You can show a visible frame above and below the block.',
		ru: 'Вы можете показать видимую рамку над и под блоком.'
	}
	hintergrundfarbe: any = {
		it: '',
		de: 'Hintergrundfarbe',
		deDu: 'Hintergrundfarbe',
		en: 'Background color',
		ru: 'Цвет фона'
	}
	klar: any = {
		it: '',
		de: 'klar',
		deDu: 'klar',
		en: 'clear',
		ru: 'очистить'
	}
	standardmabigSindInhalte: any = {
		it: '',
		de: 'Standardmäßig sind Inhalte ohne Hintergrund. Hier kann man die Hintergrundfarbe für den Block festlegen.',
		deDu: 'Standardmäßig sind Inhalte ohne Hintergrund. Hier kann man die Hintergrundfarbe für den Block festlegen.',
		en: 'By default, content is backgroundless. Here you can set the background color for the block.',
		ru: 'По умолчанию контент не имеет цвета фона. Здесь можно установить цвет фона для блока.'
	}
	primar: any = {
		it: '',
		de: 'Primär',
		deDu: 'Primär',
		en: 'Primary',
		ru: 'Первичный'
	}
	sekundar: any = {
		it: '',
		de: 'Sekundär',
		deDu: 'Sekundär',
		en: 'Secondary',
		ru: 'Вторичный'
	}
	hell: any = {
		it: '',
		de: 'Hell',
		deDu: 'Hell',
		en: 'Bright',
		ru: 'Яркий'
	}
	dieHoheDes: any = {
		it: '',
		de: 'Die Höhe des Inhalts kann auf einen festen Wert begrenzt werden oder sich automatisch dem Inhalt anpassen.',
		deDu: 'Die Höhe des Inhalts kann auf einen festen Wert begrenzt werden oder sich automatisch dem Inhalt anpassen.',
		en: 'The height of the content can be limited to a fixed value or automatically adapt to the content.',
		ru: 'Высоту содержимого можно ограничить фиксированным значением или она адаптируется автоматически.'
	}
	auto: any = {
		it: '',
		de: 'Auto',
		deDu: 'Auto',
		en: 'Auto',
		ru: 'Автоматически'
	}
	abdunkeln: any = {
		it: '',
		de: 'Abdunkeln',
		deDu: 'Abdunkeln',
		en: 'Darken',
		ru: 'Затемнить'
	}
	aufhellen: any = {
		it: '',
		de: 'Aufhellen',
		deDu: 'Aufhellen',
		en: 'Lighten',
		ru: 'Осветлить'
	}
	umDieLesbarkeit: any = {
		it: '',
		de: 'Um die Lesbarkeit des Textes auf einem Hintergrundbild zu verbessern, kann das Bild abgedunkelt oder aufgehellt werden.',
		deDu: 'Um die Lesbarkeit des Textes auf einem Hintergrundbild zu verbessern, kann das Bild abgedunkelt oder aufgehellt werden.',
		en: 'To make the text on a background image easier to read, the image can be darkened or lightened.',
		ru: 'Чтобы текст на фоновом изображении было комфортно читать, изображение можно затемнить или осветлить.'
	}
	bildflache: any = {
		it: '',
		de: 'Bildfläche',
		deDu: 'Bildfläche',
		en: 'Screen',
		ru: 'Экран'
	}
	sonstiges: any = {
		it: '',
		de: 'Sonstiges',
		deDu: 'Sonstiges',
		en: 'Other',
		ru: 'Другое'
	}
	kontaktformularEinstellungen: any = {
		it: '',
		de: 'Kontaktformular-Einstellungen',
		deDu: 'Kontaktformular-Einstellungen',
		en: 'Contact Form Settings',
		ru: 'Настройки формы контактов'
	}
	positionDerElemente: any = {
		it: '',
		de: 'Position der Elemente',
		deDu: 'Position der Elemente',
		en: 'Position of elements',
		ru: 'Положение элементов'
	}
	wahlenSie: any = {
		it: '',
		de: 'Wählen Sie das Seitenverhältnis des Bildes aus',
		deDu: 'Wählen Sie das Seitenverhältnis des Bildes aus',
		en: 'Select the aspect ratio of the image',
		ru: 'Выберите соотношение сторон изображения'
	}
	sieKonnenBilder: any = {
		it: '',
		de: 'Sie können Bilder rund machen',
		deDu: 'Sie können Bilder rund machen',
		en: 'You can make image round',
		ru: 'Вы можете сделать изображения круглыми'
	}
	abgerundeteBilder: any = {
		it: '',
		de: 'Abgerundete Bilder?',
		deDu: 'Abgerundete Bilder?',
		en: 'Rounded images?',
		ru: 'Округлить изображения?'
	}
	bild: any = {
		it: '',
		de: 'Bild',
		deDu: 'Bild',
		en: 'Image',
		ru: 'Изображение'
	}

	// Components ITEM-CARD

	kase: any = {
		it: '',
		de: 'Käse',
		deDu: 'Käse',
		en: 'Cheese',
		ru: 'Сыр'
	}
	gemuse: any = {
		it: '',
		de: 'Gemüse',
		deDu: 'Gemüse',
		en: 'Vegetables',
		ru: 'Овощи'
	}
	pilze: any = {
		it: '',
		de: 'Pilze',
		deDu: 'Pilze',
		en: 'Mushrooms',
		ru: 'Грибы'
	}
	gewurze: any = {
		it: '',
		de: 'Gewürze',
		deDu: 'Gewürze',
		en: 'Spices',
		ru: 'Специи'
	}
	listeExtrasErstellen: any = {
		it: '',
		de: 'Liste / Extras erstellen',
		deDu: 'Liste / Extras erstellen',
		en: 'List / Create extras',
		ru: 'Список / Создать новый'
	}
	listeExtrasVerlinken: any = {
		it: '',
		de: 'Liste / Extras verlinken',
		deDu: 'Liste / Extras verlinken',
		en: 'List / Link Extras',
		ru: 'Список / Создать копию'
	}
	addieren: any = {
		it: '',
		de: 'Addieren',
		deDu: 'Addieren',
		en: 'Add',
		ru: 'Добавить'
	}

	// Modal ADD-PAGE

	speichern: any = {
		it: '',
		de: 'Speichern',
		deDu: 'Speichern',
		en: 'Save',
		ru: 'Сохранить'
	}
	seitentitel: any = {
		it: '',
		de: 'Seitentitel',
		deDu: 'Seitentitel',
		en: 'Page title',
		ru: 'Заголовок страницы'
	}
	tabText: any = {
		it: '',
		de: 'Tab-Text',
		deDu: 'Tab-Text',
		en: 'Tab-Text',
		ru: 'Вкладка-Текст'
	}
	tabIcon: any = {
		it: '',
		de: 'Tab-Icon',
		deDu: 'Tab-Icon',
		en: 'Tab-Icon',
		ru: 'Вкладка-Иконка'
	}
	layout: any = {
		it: '',
		de: 'Layout',
		deDu: 'Layout',
		en: 'Layout',
		ru: 'Макет'
	}

	// Modal CHECKOUT-OVERVIEW

	ihreBuchung: any = {
		it: 'La tua prenotazione',
		de: 'Ihre Buchung',
		deDu: 'Ihre Buchung',
		en: 'Your booking',
		ru: 'Ваш заказ'
	}
	anfrage: any = {
		it: 'Richiesta',
		de: 'Anfrage',
		deDu: 'Anfrage',
		en: 'Inquiry',
		ru: 'Запрос'
	}
	ihreNachricht: any = {
		it: 'Il tuo messaggio',
		de: 'Ihre Nachricht',
		deDu: 'Deine Nachricht',
		en: 'Your message',
		ru: 'Ваше сообщение'
	}
	nachricht: any = {
		it: 'Messaggio',
		de: 'Nachricht',
		deDu: 'Nachricht',
		en: 'Message',
		ru: 'Сообщение'
	}
	zusammenfassung: any = {
		it: 'Riepilogo',
		de: 'Zusammenfassung',
		deDu: 'Zusammenfassung',
		en: 'Summary',
		ru: 'Обобщение'
	}
	kostenloseAnfrage: any = {
		it: 'Richiesta graduita',
		de: 'Kostenlose Anfrage',
		deDu: 'Kostenlose Anfrage',
		en: 'Free inquiry',
		ru: 'Бесплатный запрос'
	}
	warenkorb: any = {
		it: 'Il carrello',
		de: 'Warenkorb',
		deDu: 'Warenkorb',
		en: 'Shopping cart',
		ru: 'Корзина покупателя'
	}
	warenkorbLeeren: any = {
		it: 'Vuoti il carrello',
		de: 'Warenkorb leeren',
		deDu: 'Warenkorb leeren',
		en: 'Empty cart',
		ru: 'Очистить корзину'
	}
	listeLeeren: any = {
		it: 'Vuoti la lista',
		de: 'Liste leeren',
		deDu: 'Liste leeren',
		en: 'Empty list',
		ru: 'Очистить список'
	}
	mindBestellwert: any = {
		it: 'Valore minimo dell\'ordinazione',
		de: 'Mind. Bestellwert',
		deDu: 'Mind. Bestellwert',
		en: 'Min. order value',
		ru: 'Мин. цена заказа'
	}
	nicht: any = {
		it: 'non raggiunto',
		de: 'nicht erreicht',
		deDu: 'nicht erreicht',
		en: 'not reached',
		ru: 'не достигнуто'
	}
	tabak: any = {
		it: '',
		de: 'Tabak- & CBD-Artikel, sowie Prepaid Karten zählen nicht in den Warenwert.',
		deDu: 'Tabak- & CBD-Artikel, sowie Prepaid Karten zählen nicht in den Warenwert.',
		en: 'Tobacco & CBD items and prepaid cards do not count towards the value of goods.',
		ru: 'Tobacco & CBD items and prepaid cards do not count towards the value of goods.'
	}
	eingeloster: any = {
		it: '',
		de: 'Eingelöster Gutschein',
		deDu: 'Eingelöster Gutschein',
		en: 'Redeemed Coupon',
		ru: 'Использованный купон'
	}
	code: any = {
		it: '',
		de: 'Code:',
		deDu: 'Code:',
		en: 'Code:',
		ru: 'Код:'
	}
	fachNr: any = {
		it: '',
		de: 'Fach Nr.',
		deDu: 'Fach Nr.',
		en: 'Compartment no.',
		ru: 'Номер ячейки'
	}
	bitteWarten: any = {
		it: '',
		de: 'BITTE WARTEN',
		deDu: 'BITTE WARTEN',
		en: 'PLEASE WAIT',
		ru: 'ПОЖАЛУЙСТА, ПОДОЖДИТЕ'
	}
	bestellung: any = {
		it: '',
		de: 'Bestellung wird übertragen.',
		deDu: 'Bestellung wird übertragen.',
		en: 'Order is transferred.',
		ru: 'Заказ передан.'
	}
	appFenster: any = {
		it: '',
		de: 'App / Fenster auf keinen Fall schließen!',
		deDu: 'App / Fenster auf keinen Fall schließen!',
		en: 'Never close the app / window!',
		ru: 'Никогда не закрывайте приложение / окно!'
	}
	weiter: any = {
		it: 'Avanti',
		de: 'Weiter',
		deDu: 'Weiter',
		en: 'Continue',
		ru: 'Продолжить'
	}
	kontaktdaten: any = {
		it: '',
		de: 'Kontaktdaten',
		deDu: 'Kontaktdaten',
		en: 'Contact data',
		ru: 'Контактные данные'
	}
	zahlung: any = {
		it: '',
		de: 'Zahlung',
		deDu: 'Zahlung',
		en: 'Payment',
		ru: 'Оплата'
	}
	versand: any = {
		it: '',
		de: 'Versand',
		deDu: 'Versand',
		en: 'Shipping',
		ru: 'Доставка'
	}
	versandPerPost: any = {
		it: '',
		de: 'Versand per Post',
		deDu: 'Versand per Post',
		en: 'Shipping via postal service',
		ru: 'Доставка почтовой службой'
	}
	zuTisch: any = {
		it: '',
		de: 'Zu Tisch',
		deDu: 'Zu Tisch',
		en: 'To table',
		ru: 'К столу'
	}
	abholung: any = {
		it: '',
		de: 'Abholung',
		deDu: 'Abholung',
		en: 'Pickup',
		ru: 'Подобрать'
	}
	lieferung: any = {
		it: '',
		de: 'Lieferung',
		deDu: 'Lieferung',
		en: 'Delivery',
		ru: 'Доставка'
	}
	vorubergehend: any = {
		it: '',
		de: 'Vorübergehend geschlossen',
		deDu: 'Vorübergehend geschlossen',
		en: 'Temporarily closed',
		ru: 'Временно закрыто'
	}
	adresseSpeichern: any = {
		it: '',
		de: 'Adresse speichern',
		deDu: 'Adresse speichern',
		en: 'Save address',
		ru: 'Сохранить адрес'
	}
	strabeNr: any = {
		it: '',
		de: 'Straße + Nr.',
		deDu: 'Straße + Nr.',
		en: 'Street + numb.',
		ru: 'Улица + номер'
	}
	stadt: any = {
		it: '',
		de: 'Stadt',
		deDu: 'Stadt',
		en: 'City',
		ru: 'Город'
	}
	mail: any = {
		it: '',
		de: 'E-Mail',
		deDu: 'E-Mail',
		en: 'E-mail',
		ru: 'Эл. почта'
	}
	hinweisOptional: any = {
		it: 'Il tuo messaggio',
		de: 'Hinweis (optional)',
		deDu: 'Hinweis (optional)',
		en: 'Note (optional)',
		ru: 'Примечание (необязательно)'
	}
	payPal: any = {
		it: '',
		de: 'PayPal',
		deDu: 'PayPal',
		en: 'PayPal',
		ru: 'PayPal'
	}
	payPalGuthaben: any = {
		it: '',
		de: 'PayPal Guthaben | Lastschrift',
		deDu: 'PayPal Guthaben | Lastschrift',
		en: 'PayPal Balance | Automatic withdrawal',
		ru: 'Баланс PayPal | Автоматический вывод'
	}
	startenSie: any = {
		it: '',
		de: 'Starten Sie den Bezahlungsprozess, indem Sie auf den PayPal Button klicken:',
		deDu: 'Starten Sie den Bezahlungsprozess, indem Sie auf den PayPal Button klicken:',
		en: 'Start payment by clicking the PayPal button:',
		ru: 'Начните оплату, нажав кнопку PayPal:'
	}
	kreditkarte: any = {
		it: '',
		de: 'Kreditkarte',
		deDu: 'Kreditkarte',
		en: 'Credit card',
		ru: 'Кредитная карта'
	}
	oderKlarna: any = {
		it: '',
		de: 'oder Klarna',
		deDu: 'oder Klarna',
		en: 'or Klarna',
		ru: 'или Klarna'
	}
	mitKreditkarte: any = {
		it: '',
		de: 'Mit Kreditkarte',
		deDu: 'Mit Kreditkarte',
		en: 'Pay with credit card',
		ru: 'Оплатить кредитной картой'
	}
	zahlen: any = {
		it: '',
		de: 'zahlen',
		deDu: 'zahlen',
		en: '',
		ru: ''
	}
	barzahlung: any = {
		it: '',
		de: 'Barzahlung',
		deDu: 'Barzahlung',
		en: 'Pay by cash',
		ru: 'Оплата наличными'
	}
	zahlungAnDen: any = {
		it: '',
		de: 'Zahlung an den Lieferanten bei der Übergabe',
		deDu: 'Zahlung an den Lieferanten bei der Übergabe',
		en: 'Payment to the supplier upon delivery',
		ru: 'Оплата поставщику при доставке'
	}
	kostenpflichtig: any = {
		it: '',
		de: 'Kostenpflichtig bestellen',
		deDu: 'Kostenpflichtig bestellen',
		en: 'Order',
		ru: 'Заказать'
	}
	verbindlichBestellen: any = {
		it: '',
		de: 'Verbindlich bestellen',
		deDu: 'Verbindlich bestellen',
		en: 'Order',
		ru: 'Заказать'
	}
	bestellen: any = {
		it: '',
		de: 'Bestellen',
		deDu: 'Bestellen',
		en: 'Order',
		ru: 'Заказать'
	}
	hinweisZurBestellung: any = {
		it: '',
		de: 'Hinweis zur Bestellung',
		deDu: 'Ordering notes',
		en: 'Order comments',
		ru: 'Замечания по заказу'
	}
	Mobiltelefon: any = {
		it: 'Cellulare',
		de: 'Mobiltelefon',
		deDu: 'Mobiltelefon',
		en: 'Mobile phone no.',
		ru: 'Мобильный телефон'
	}
	eCKarte: any = {
		it: '',
		de: 'EC-Karte',
		deDu: 'EC-Karte',
		en: 'Pay contactless by card',
		ru: 'Бесконтактная оплата картой'
	}
	kontaktlosPer: any = {
		it: '',
		de: 'Kontaktlos per Karte zahlen bei Übergabe',
		deDu: 'Kontaktlos per Karte zahlen bei Übergabe',
		en: 'Pay contactless by card when handing over',
		ru: 'Бесконтактная оплата картой при доставке'
	}
	rechnung: any = {
		it: '',
		de: 'Rechnung',
		deDu: 'Rechnung',
		en: 'Invoice',
		ru: 'По счету'
	}
	aufRechnung: any = {
		it: '',
		de: 'Auf Rechnung bestellen',
		deDu: 'Auf Rechnung bestellen',
		en: 'Pay later',
		ru: 'Заплатить позже'
	}
	nachnahme: any = {
		it: '',
		de: 'Nachnahme',
		deDu: 'Nachnahme',
		en: 'Cash on delivery',
		ru: 'Оплата при доставке'
	}
	vorkasse: any = {
		it: '',
		de: 'Vorkasse',
		deDu: 'Vorkasse',
		en: 'Cash in advance',
		ru: 'Предоплата'
	}
	trinkgeldAuswahlen: any = {
		it: '',
		de: 'Trinkgeld auswählen',
		deDu: 'Trinkgeld auswählen',
		en: 'Select tip',
		ru: 'Выберите чаевые'
	}
	aufrunden: any = {
		it: '',
		de: 'aufrunden',
		deDu: 'aufrunden',
		en: 'round up',
		ru: 'округлить'
	}
	erhaltVonInformationen: any = {
		it: '',
		de: '<strong>Erhalt von Informationen akzeptieren</strong><span><br />Nur so können wir dich über Änderungen am Zubereitungs-, Abholungs- oder Lieferzeitpunkt informieren und bei Fragen Kontakt zu dir aufnehmen.</span>',
		deDu: '<strong>Erhalt von Informationen akzeptieren</strong><span><br />Nur so können wir dich über Änderungen am Zubereitungs-, Abholungs- oder Lieferzeitpunkt informieren und bei Fragen Kontakt zu dir aufnehmen.</span>',
		en: '<strong>Accept receipt of information</strong><span><br />This is the only way we can inform you about changes to the preparation, collection or delivery time and contact you if we have any questions.</span>',
		ru: '<strong>Принять получение информации</strong><span><br />Это единственный способ сообщить вам об изменениях в подготовке, сборе или времени доставки и связаться с вами, если у нас возникнут вопросы.</span>'
	}

	geschlossen: any = {
		it: '',
		de: 'Geschlossen',
		deDu: 'Geschlossen',
		en: 'Closed',
		ru: 'Закрыто'
	}
	enSind: any = {
		it: '',
		de: 'Bestellungen sind aktuell nicht möglich',
		deDu: 'Bestellungen sind aktuell nicht möglich',
		en: 'It is currently not possible to place an order',
		ru: 'Заказать в данный момент невозможно'
	}
	agbLinks: any = {
		it: '',
		de: '<a href="/shop/agbs" target="_blank">AGB</a> und <a href="/shop/datenschutz" target="_blank">Datenschutzerklärung</a> akzeptieren',
		deDu: '<a href="/shop/agbs" target="_blank">AGB</a> und <a href="/shop/datenschutz" target="_blank">Datenschutzerklärung</a> akzeptieren',
		en: 'Accept <a href="/shop/agbs" target="_blank">Terms & Conditions</a> and <a href="/shop/datenschutz" target="_blank">data protection</a>',
		ru: 'Принять <a href="/shop/agbs" target="_blank">условия обслуживания</a> и <a href="/shop/datenschutz" target="_blank">политику конфиденциальности</a>'
	}
	widerrufsbelehrungLinks: any = {
		it: '',
		de: '<a href="/shop/widerruf" target="_blank">Widerrufsbelehrung</a> akzeptieren',
		deDu: '<a href="/shop/widerruf" target="_blank">Widerrufsbelehrung</a> akzeptieren',
		en: 'Accept <a href="/shop/widerruf" target="_blank">cancellation policy</a>',
		ru: 'Принять <a href="/shop/widerruf" target="_blank">политику отмены</a>'
	}

	bitteAkzeptieren: any = {
		it: '',
		de: 'Bitte akzeptieren Sie unsere AGB, Datenschutzerklärung und ob wir Ihnen E-Mails senden dürfen (optional)',
		deDu: 'Bitte akzeptieren Sie unsere AGB, Datenschutzerklärung und ob wir Ihnen E-Mails senden dürfen (optional)',
		en: 'Accept our terms & conditions, data protection and allow us to contact you via e-mail (optional).',
		ru: 'Прмите условия обслуживания, политику конфиденциальности / отмены и разрешите нам связаться с вами по электронной почте (необязательно).'
	}
	bitteAkzeptierenSie: any = {
		it: '',
		de: 'Bitte akzeptieren Sie unsere AGB, Datenschutzerklärung und Widerrufsbelehrung',
		deDu: 'Bitte akzeptieren Sie unsere AGB, Datenschutzerklärung und Widerrufsbelehrung',
		en: 'Accept our terms & conditions, data protection and cancellation policy',
		ru: 'Примите условия обслуживания, политику конфиденциальности и отмены'
	}

	angebote: any = {
		it: 'Occasioni e sconti da inviare tramite e-mail',
		de: 'Angebote und Rabattcodes per E-Mail abonnieren',
		deDu: 'Angebote und Rabattcodes per E-Mail abonnieren',
		en: 'Subscribe to special offers and discount codes via email',
		ru: 'Подпишитесь на специальные предложения по электронной почте'
	}
	summe: any = {
		it: 'Somma',
		de: 'Summe',
		deDu: 'Summe',
		en: 'Sum',
		ru: 'Сумма'
	}
	netto: any = {
		it: 'Netto',
		de: 'Netto',
		deDu: 'Netto',
		en: 'Net',
		ru: 'без налога'
	}
	mwSt: any = {
		it: 'IVA',
		de: 'MwSt.',
		deDu: 'MwSt.',
		en: 'VAT',
		ru: 'НДС'
	}
	trinkgeld: any = {
		it: '',
		de: 'Trinkgeld',
		deDu: 'Trinkgeld',
		en: 'Gratuity',
		ru: 'Чаевые'
	}
	bearbeitung: any = {
		it: '',
		de: 'Bearbeitung',
		deDu: 'Bearbeitung',
		en: 'Editing',
		ru: 'Редактирование'
	}
	ausraumpauschale: any = {
		it: '',
		de: '& Ausräumpauschale',
		deDu: '& Ausräumpauschale',
		en: '& clearance fee',
		ru: 'и плата за оформление'
	}
	mind: any = {
		it: '',
		de: 'Mind. Bestellwert Aufschlag',
		deDu: 'Mind. Bestellwert Aufschlag',
		en: 'Min. Order value surcharge',
		ru: 'Мин. надбавка к стоимости заказа'
	}
	ihreBestellung: any = {
		it: '',
		de: 'Ihre Bestellung #{{basket.lastOrder.order.id}} ist bei uns eingegangen.',
		deDu: 'Ihre Bestellung #{{basket.lastOrder.order.id}} ist bei uns eingegangen.',
		en: 'We received your order #{{basket.lastOrder.order.id}}',
		ru: 'Мы получили ваш заказ №{{basket.lastOrder.order.id}}'
	}
	bitteHalte: any = {
		it: '',
		de: 'Bitte halte den Betrag {{basket.formatted(basket.lastOrder.order.total)}} <strong>möglichst passend</strong> bereit.',
		deDu: 'Bitte halte den Betrag {{basket.formatted(basket.lastOrder.order.total)}} <strong>möglichst passend</strong> bereit.',
		en: 'Please have the amount {{basket.formatted(basket.lastOrder.order.total)}} <strong>as appropriate</strong> ready.',
		ru: 'Подготовьте сумму {{basket.formatted(basket.lastOrder.order.total)}} <strong>при необходимости</strong>.'
	}
	bitteHalteDeine: any = {
		it: '',
		de: 'Bitte halte deine EC-Karte für die Zahlung von {{basket.formatted(basket.lastOrder.order.total)}} bereit.',
		deDu: 'Bitte halte deine EC-Karte für die Zahlung von {{basket.formatted(basket.lastOrder.order.total)}} bereit.',
		en: 'Please have your debit card ready to pay {{basket.formatted(basket.lastOrder.order.total)}}.',
		ru: 'Пожалуйста, приготовьте свою дебетовую карту для оплаты {{basket.formatted(basket.lastOrder.order.total)}}.'
	}
	derBetrag: any = {
		it: '',
		de: 'Der Betrag',
		deDu: 'Der Betrag',
		en: 'The amount of',
		ru: 'Сумма'
	}
	wurdeErfolgreichMit: any = {
		it: '',
		de: 'wurde erfolgreich mit {{basket.lastOrder.order.paymentOption}} bezahlt.',
		deDu: 'wurde erfolgreich mit {{basket.lastOrder.order.paymentOption}} bezahlt.',
		en: 'was charged to your {{basket.lastOrder.order.paymentOption}}',
		ru: 'была списана с вашей {{basket.lastOrder.order.paymentOption}}'
	}
	beiFragenKonnen: any = {
		it: '',
		de: 'Bei Fragen können Sie sich gerne an uns wenden:',
		deDu: 'Bei Fragen können Sie sich gerne an uns wenden:',
		en: "In case of any questions don't hesitate to ask us:",
		ru: 'Если у вас есть какие-либо вопросы, пожалуйста, не стесняйтесь обращаться к нам:'
	}
	vielenDank: any = {
		it: '',
		de: 'Vielen Dank!',
		deDu: 'Vielen Dank!',
		en: 'Thank you very much!',
		ru: 'Большое спасибо!'
	}
	vielenDankFuerAnfrage: any = {
		it: 'Grazie per la vostra richiesta',
		de: 'Vielen Dank für Ihre Anfrage',
		deDu: 'Vielen Dank für deine Anfrage',
		en: 'Thank you for your inquiry',
		ru: 'Спасибо за ваш запрос'
	}
	wirVersuchenDieAnfrage: any = {
		it: 'Cerchiamo di rispondere alla tua richiesta il prima possibile.',
		de: 'Wir versuchen Ihre Anfrage so schnell wie möglich zu beantworten.',
		deDu: 'Wir versuchen deine Anfrage so schnell wie möglich zu beantworten.',
		en: 'We\'ll try to reply as soon as possible.',
		ru: 'Мы постараемся ответить как можно скорее.'
	}

	derBezahlungvorgang: any = {
		it: '',
		de: 'Der Bezahlungvorgang wird geprüft',
		deDu: 'Der Bezahlungvorgang wird geprüft',
		en: 'The payment process is being checked.',
		ru: 'Процесс оплаты проверяется.'
	}
	bitteLassSie: any = {
		it: '',
		de: 'Bitte lassen Sie das Fenster noch einen Augenblick offen.',
		deDu: 'Bitte lassen Sie das Fenster noch einen Augenblick offen.',
		en: 'Please leave the window open for a moment.',
		ru: 'Пожалуйста, ненадолго оставьте окно открытым.'
	}
	dieZahlung: any = {
		it: '',
		de: 'Die Zahlung ist fehlgeschlagen',
		deDu: 'Die Zahlung ist fehlgeschlagen',
		en: 'Payment denied',
		ru: 'Платёж отклонён'
	}
	dieseWurdeUber: any = {
		it: '',
		de: 'Diese wurde über eine andere Webseite oder App gestartet',
		deDu: 'Diese wurde über eine andere Webseite oder App gestartet',
		en: 'It was started via another website or app',
		ru: 'Он был запущен через другой веб-сайт или приложение'
	}
	versuchenSieEs: any = {
		it: '',
		de: 'Versuchen Sie es deswegen dort erneut oder probieren Sie eine andere Zahlungsmethode aus.',
		deDu: 'Versuchen Sie es deswegen dort erneut oder probieren Sie eine andere Zahlungsmethode aus.',
		en: 'So try it there again or choose another payment method.',
		ru: 'Так что попробуйте ещё раз или выберите другой способ оплаты.'
	}
	sofernDuDie: any = {
		it: '',
		de: 'Sofern du die Webseite oder App bereits geschlossen hast, kannst du diese einfach erneut öffnen. Die Daten wurden zwischengespeichert, sodass du einfach direkt zur Kasse gehen kannst.',
		deDu: 'Sofern du die Webseite oder App bereits geschlossen hast, kannst du diese einfach erneut öffnen. Die Daten wurden zwischengespeichert, sodass du einfach direkt zur Kasse gehen kannst.',
		en: 'If you closed the website or app already, just open it again. Your data was saved, so you can just proceed to the checkout.',
		ru: 'Если вы уже закрыли веб-сайт или приложение, просто откройте его снова. Ваши данные были сохранены, так что вы можете просто перейти к оформлению заказа.'
	}
	aktionFehlgeschlagen1: any = {
		it: '',
		de: 'Aktion fehlgeschlagen (1)',
		deDu: 'Aktion fehlgeschlagen (1)',
		en: 'Error (1)',
		ru: 'Ошибка (1)'
	}
	stripeZahlung: any = {
		it: '',
		de: 'Stripe Zahlung war nicht erfolgreich. Bitte ändern Sie ggf. Ihre Zahlungsart oder versuchen Sie es erneut.',
		deDu: 'Stripe Zahlung war nicht erfolgreich. Bitte ändern Sie ggf. Ihre Zahlungsart oder versuchen Sie es erneut.',
		en: 'Stripe payment not successful. Change your payment method or try again.',
		ru: 'Полосатый платеж не успешен. Измените способ оплаты или повторите попытку.'
	}
	stripeZahlungWar: any = {
		it: '',
		de: 'Stripe Zahlung war nicht erfolgreich. Bitte gehen Sie zurück in die App und starten Sie den Bezahlungsvorgang erneut oder ändern Sie die Zahlungsmethode.',
		deDu: 'Stripe Zahlung war nicht erfolgreich. Bitte gehen Sie zurück in die App und starten Sie den Bezahlungsvorgang erneut oder ändern Sie die Zahlungsmethode.',
		en: 'Stripe payment not successful. Go back to the app and start the payment again or change your payment method.',
		ru: 'Полосатый платеж не успешен. Вернитесь в приложение и снова начните оплату или измените способ оплаты.'
	}
	zahlungFehlgeschlagen: any = {
		it: '',
		de: 'Zahlung fehlgeschlagen',
		deDu: 'Zahlung fehlgeschlagen',
		en: 'Payment not successful',
		ru: 'Платёж не удался'
	}
	fehlendeAngaben: any = {
		it: 'Informazioni mancanti',
		de: 'Fehlende Angaben:',
		deDu: 'Fehlende Angaben:',
		en: 'Missing information:',
		ru: 'Недостаёт информации:'
	}
	bitteFullen: any = {
		it: 'Si prega di compilare tutte le caselle accuratamente',
		de: 'Bitte füllen Sie alle Felder sorgfältig aus.',
		deDu: 'Bitte füllen Sie alle Felder sorgfältig aus.',
		en: 'Please fill in all fields carefully',
		ru: 'Пожалуйста, внимательно заполните все поля'
	}
	zustimmungErforderlich: any = {
		it: 'Il tuo consenso è necessario',
		de: 'Zustimmung erforderlich:',
		deDu: 'Zustimmung erforderlich:',
		en: 'Approval required',
		ru: 'Требуется подтверждение'
	}
	fehlerhafteAngaben: any = {
		it: 'Informazioni errati:',
		de: 'Fehlerhafte Angaben:',
		deDu: 'Fehlerhafte Angaben:',
		en: 'Incorrect information',
		ru: 'Неверная информация'
	}
	bitteGebenSie: any = {
		it: 'Si prega di inserire un\'indirizzo e-mail valido',
		de: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
		deDu: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
		en: 'Please fill in an valid email address.',
		ru: 'Пожалуйста, введите действительный адрес эл. почты.'
	}
	wunschzeitErforderlich: any = {
		it: '',
		de: 'Wunschzeit erforderlich:',
		deDu: 'Wunschzeit erforderlich:',
		en: 'Desired time required:',
		ru: 'Желаемое время:'
	}
	bitteWahleEine: any = {
		it: '',
		de: 'Bitte wähle eine Wunschzeit aus der Liste verfügbarer Zeiten',
		deDu: 'Bitte wähle eine Wunschzeit aus der Liste verfügbarer Zeiten',
		en: 'Please select a preferred time from the list of available times',
		ru: 'Пожалуйста, выберите предпочтительное время из списка доступных'
	}
	aktionFehlgeschlagen: any = {
		it: '',
		de: 'Aktion fehlgeschlagen',
		deDu: 'Aktion fehlgeschlagen',
		en: 'Error',
		ru: 'Ошибка'
	}
	payPalZahlung: any = {
		it: '',
		de: 'PayPal Zahlung war nicht erfolgreich. Bitte ändern Sie ggf. Ihre Zahlungsart oder versuchen Sie es erneut.',
		deDu: 'PayPal Zahlung war nicht erfolgreich. Bitte ändern Sie ggf. Ihre Zahlungsart oder versuchen Sie es erneut.',
		en: 'PayPal payment not successful. Change your payment method or try again.',
		ru: 'Платёж через PayPal не прошёл. Измените способ оплаты или повторите попытку.'
	}
	dieBezahlung: any = {
		it: '',
		de: 'Die Bezahlung war erfolgreich',
		deDu: 'Die Bezahlung war erfolgreich',
		en: 'Payment successful',
		ru: 'Оплата прошла успешно'
	}
	uberprufenSieIhr: any = {
		it: '',
		de: 'Überprüfen Sie Ihr E-Mail Konto (auch den SPAM Ordner). Danach können Sie das Fenster / die App schließen.',
		deDu: 'Überprüfen Sie Ihr E-Mail Konto (auch den SPAM Ordner). Danach können Sie das Fenster / die App schließen.',
		en: 'Check your e-mail account (also SPAM). Then you can close the window / the app.',
		ru: 'Проверьте свою электронную почту (также папку СПАМ). Затем вы можете закрыть окно / приложение.'
	}
	aktionFehlgeschlagen3: any = {
		it: '',
		de: 'Aktion fehlgeschlagen (3)',
		deDu: 'Aktion fehlgeschlagen (3)',
		en: 'Error (3)',
		ru: 'Ошибка (3)'
	}
	aktionFehlgeschlagen4: any = {
		it: '',
		de: 'Aktion fehlgeschlagen (4)',
		deDu: 'Aktion fehlgeschlagen (4)',
		en: 'Error (4)',
		ru: 'Ошибка (4)'
	}

	alleAkzeptieren: any = {
		it: '',
		de: 'Alle akzeptieren',
		deDu: 'Alle akzeptieren',
		en: 'Accept all',
		ru: 'Принять всё'
	}
	fehler: any = {
		it: '',
		de: 'Fehler',
		deDu: 'Fehler',
		en: 'Error',
		ru: 'Ошибка'
	}
	plzUngultig: any = {
		it: '',
		de: 'PLZ ungültig',
		deDu: 'PLZ ungültig',
		en: 'Zip code invalid',
		ru: 'Почтовый индекс недействителен'
	}
	bitteGibDeine: any = {
		it: '',
		de: 'Bitte gib deine vollständige und gültige PLZ ein!',
		deDu: 'Bitte gib deine vollständige und gültige PLZ ein!',
		en: 'Please enter your complete and valid ZIP code!',
		ru: 'Пожалуйста, введите ваш полный и действительный почтовый индекс!'
	}
	akzeptieren: any = {
		it: '',
		de: 'Akzeptieren',
		deDu: 'Akzeptieren',
		en: 'Accept',
		ru: 'Принять'
	}
	verlangerungNicht: any = {
		it: '',
		de: 'Verlängerung nicht abgeschlossen',
		deDu: 'Verlängerung nicht abgeschlossen',
		en: 'Extension not complete',
		ru: 'Продление не завершено'
	}
	mochtenSieDie: any = {
		it: '',
		de: 'Möchten Sie die Verlängerung der Miete wirklich abbrechen und den Warenkorb leeren?',
		deDu: 'Möchten Sie die Verlängerung der Miete wirklich abbrechen und den Warenkorb leeren?',
		en: 'Do you really want to cancel the extension and empty out the shopping cart',
		ru: 'Вы действительно хотите отменить продление и очистить корзину?'
	}


	// Modal CHOOSE-ITEM

	verknupfungErstellen: any = {
		it: '',
		de: 'Verknüpfung erstellen',
		deDu: 'Verknüpfung erstellen',
		en: 'Create link',
		ru: 'Создать ссылку'
	}

	bitteWahlen: any = {
		it: '',
		de: 'Bitte wählen:',
		deDu: 'Bitte wählen:',
		en: 'Please choose:',
		ru: 'Пожалуйста выберите:'
	}
	neuenEintrag: any = {
		it: '',
		de: 'Neuen Eintrag erstellen',
		deDu: 'Neuen Eintrag erstellen',
		en: 'Create new entry',
		ru: 'Создать новую запись'
	}
	bestehendenEintrag: any = {
		it: '',
		de: 'Bestehenden Eintrag ändern',
		deDu: 'Bestehenden Eintrag ändern',
		en: 'Change existing entry',
		ru: 'Изменить существующую запись'
	}
	verknupfenMit: any = {
		it: '',
		de: 'Verknüpfen mit:',
		deDu: 'Verknüpfen mit:',
		en: 'Link to:',
		ru: 'Ссылка на:'
	}
	nr: any = {
		it: '',
		de: 'Nr:',
		deDu: 'Nr:',
		en: 'Numb:',
		ru: 'Номер:'
	}
	bereits: any = {
		it: '',
		de: 'Bereits im Block verknüpft',
		deDu: 'Bereits im Block verknüpft',
		en: 'Already linked in the block',
		ru: 'Ссылка уже в блоке'
	}

	// Modal COOKIE-BAR

	wirVerwendenCookies: any = {
		it: 'Usiamo Cookies',
		de: 'Wir verwenden Cookies',
		deDu: 'Wir verwenden Cookies',
		en: 'We use cookies',
		ru: 'Мы используем файлы cookie'
	}
	wennSieUnsere: any = {
		it: 'Quando visiti i nostri siti Web, il software del tuo sistema può recuperare o memorizzare informazioni da noi e dai nostri partner sotto forma di cookie o altre tecnologie, ad esempio per garantire il funzionamento desiderato del sito Web.',
		de: 'Wenn Sie unsere Webseiten besuchen, kann Ihre Systemsoftware Informationen in Form von Cookies oder anderen Technologien von uns und unseren Partnern abrufen oder speichern, um z.B. die gewünschte Funktion der Website zu gewährleisten.',
		deDu: 'Wenn Sie unsere Webseiten besuchen, kann Ihre Systemsoftware Informationen in Form von Cookies oder anderen Technologien von uns und unseren Partnern abrufen oder speichern, um z.B. die gewünschte Funktion der Website zu gewährleisten.',
		en: 'When you visit our websites, your system software can retrieve or store information from us and our partners in the form of cookies or other technologies, e.g. to ensure the desired function of the website.',
		ru: 'Когда вы посещаете наши веб-сайты, ваше системное программное обеспечение может получать или сохранять информацию от нас и наших партнеров в виде файлов cookie или других технологий, например, для обеспечения желаемой работы веб-сайта.'
	}


	// Modal COOKIE-MODAL

	datenschutzEinstellungen: any = {
		it: 'Impostazioni della privacy',
		de: 'Datenschutz-Einstellungen',
		deDu: 'Datenschutz-Einstellungen',
		en: 'Privacy-Settings',
		ru: 'Настройки-конфиденциальности'
	}
	hierKonnenSie: any = {
		it: 'Qui puoi specificare come potremmo utilizzare i tuoi dati. Tieni presente che, in base alle tue impostazioni, non tutte le funzioni potrebbero essere disponibili.',
		de: 'Hier können Sie festlegen, wie wir Ihre Daten verwenden dürfen. Bitte beachten Sie, dass auf Basis Ihrer Einstellungen womöglich nicht mehr alle Funktionen zur Verfügung stehen.',
		deDu: 'Hier können Sie festlegen, wie wir Ihre Daten verwenden dürfen. Bitte beachten Sie, dass auf Basis Ihrer Einstellungen womöglich nicht mehr alle Funktionen zur Verfügung stehen.',
		en: 'Here you can specify how we may use your data. Please note that based on your settings, not all functions may be available.',
		ru: 'Здесь вы можете указать, как мы можем использовать ваши данные. Обратите внимание, что в зависимости от ваших настроек, некоторые функции могут быть недоступны.'
	}
	auswahlSpeichern: any = {
		it: 'Salvi la scelta',
		de: 'Auswahl speichern',
		deDu: 'Auswahl speichern',
		en: 'Save Selection',
		ru: 'Сохранить настройки'
	}


	// Modal EDIT-BUTTON

	artikelBearbeiten: any = {
		it: '',
		de: 'Artikel bearbeiten',
		deDu: 'Artikel bearbeiten',
		en: 'Edit article',
		ru: 'Изменить контент'
	}


	// Modal EDIT-CONTAINER


	optionen: any = {
		it: 'Opzioni',
		de: 'Optionen',
		deDu: 'Optionen',
		en: 'Options',
		ru: 'Параметры'
	}

	// Modal UNSPLASH
	kostenloseStockphotosAnzeigen: any = {
		it: 'mostri le foto graduite',
		de: 'Kostenl. Stockfotos anzeigen',
		deDu: 'Kostenl. Stockfotos anzeigen',
		en: 'Show free stockphotos',
		ru: 'Бесплатные стоковые фотографии',
	}
	zumFotoUpload: any = {
		it: 'Vai a caricare le foto',
		de: 'Zum Foto-Upload',
		deDu: 'Zum Foto-Upload',
		en: 'Upload own photos',
		ru: 'К загрузке фото',
	}
	bildHochladen: any = {
		it: 'Carichi una foto',
		de: 'Bild hochladen',
		deDu: 'Bild hochladen',
		en: 'Upload image',
		ru: 'Загрузить изображение'
	}
	bilderGalerie: any = {
		it: 'Galeria delle foto',
		de: 'Bilder Galerie',
		deDu: 'Bilder Galerie',
		en: 'Photo gallery',
		ru: 'Галерея изображений'
	}
	esBefindenSichNochKeineFotos: any = {
		it: '',
		de: 'Es befinden sich noch keine Fotos in der Galerie.<br />Laden Sie das erste Foto hoch oder wählen Sie aus einer Vielzahl von kostenlosen Stockfotos.',
		deDu: 'Es befinden sich noch keine Fotos in der Galerie.<br />Lade das erste Foto hoch oder wählen aus einer Vielzahl von kostenlosen Stockfotos.',
		en: 'There are no photos in the gallery yet.<br />Upload the first photo or choose from a variety of free stock photos.',
		ru: 'В галерее пока нет фотографий.<br />Загрузите первую фотографию или выберите из множества бесплатных стоковых фотографий.',
	}
	ladenSieFotosHoch: any = {
		it: '',
		de: 'Laden Sie Fotos hoch oder wählen Sie aus kostenlosen Stockfotos',
		deDu: 'Lade Fotos hoch oder wählen aus kostenlosen Stockfotos',
		en: 'Upload photos or choose from free stock photos',
		ru: 'Загрузите фотографии или выберите из бесплатных стоковых фотографий'
	}
	lizenzfreieFotos: any = {
		it: '',
		de: 'Lizenzfreie Fotos',
		deDu: 'Lizenzfreie Fotos',
		en: 'Royalty free photos',
		ru: 'Фотографии без лицензии'
	}

	ergebnisseZeige: any = {
		it: '',
		de: 'Ergebnisse - Zeige',
		deDu: 'Ergebnisse - Zeige',
		en: 'Results - Show',
		ru: 'Результаты - показать'
	}
	weitereBilderladen: any = {
		it: 'Mostri di piu',
		de: 'Mehr anzeigen',
		deDu: 'Mehr anzeigen',
		en: 'Load more',
		ru: 'Загрузить больше'
	}

	neuenArtikel: any = {
		it: 'Aggiungi un nuovo articolo',
		de: 'Neuen Artikel erstellen',
		deDu: 'Neuen Artikel erstellen',
		en: 'Create new article',
		ru: 'Создать новый контент'
	}
	bestehendenArtikel: any = {
		it: 'Aggiungi un\'articolo esistente',
		de: 'Bestehenden Artikel hinzufügen',
		deDu: 'Bestehenden Artikel hinzufügen',
		en: 'Add existing item',
		ru: 'Добавить существующий элемент'
	}

	eintragWirklich: any = {
		it: 'Vuoi cancellare davvero?',
		de: 'Eintrag wirklich entfernen?',
		deDu: 'Eintrag wirklich entfernen?',
		en: 'Really remove entry?',
		ru: 'Уверены, что хотите удалить запись?'
	}
	jaEntfernen: any = {
		it: 'Si, da cancellare',
		de: 'Ja, entfernen',
		deDu: 'Ja, entfernen',
		en: 'Yes, remove',
		ru: 'Да, удалить'
	}

	// Modal UNSPLASH-MULTI



	// Modal LOCKER-ARCHIVE

	laufendeFachmieten: any = {
		it: '',
		de: 'Laufende Fachmieten',
		deDu: 'Laufende Fachmieten',
		en: 'Ongoing specialist rentals',
		ru: 'Постоянная аренда специалистов'
	}

	mieteBeenden: any = {
		it: '',
		de: 'Miete beenden',
		deDu: 'Miete beenden',
		en: 'End rental',
		ru: 'Закончить аренду'
	}
	nachzahlen: any = {
		it: '',
		de: 'Nachzahlen',
		deDu: 'Nachzahlen',
		en: 'Pay extra',
		ru: 'Оплатить'
	}
	verlangern: any = {
		it: '',
		de: 'Verlängern',
		deDu: 'Verlängern',
		en: 'Extend',
		ru: 'Продлить'
	}
	fachmieteVerlangern: any = {
		it: '',
		de: 'Fachmiete verlängern',
		deDu: 'Fachmiete verlängern',
		en: 'Extend rental period',
		ru: 'Продлить срок аренды'
	}

	start: any = {
		it: '',
		de: 'Start',
		deDu: 'Start',
		en: 'Begin',
		ru: 'Начать'
	}

	bestellarchiv: any = {
		it: '',
		de: 'Bestellarchiv',
		deDu: 'Bestellarchiv',
		en: 'Order archive',
		ru: 'Архив заказов'
	}
	bestell: any = {
		it: '',
		de: 'Bestell',
		deDu: 'Bestell',
		en: 'Order',
		ru: 'Заказ'
	}

	ende: any = {
		it: '',
		de: 'Ende',
		deDu: 'Ende',
		en: 'End',
		ru: 'Конец'
	}
	bestellNr: any = {
		it: '',
		de: 'Bestell-Nr.:',
		deDu: 'Bestell-Nr.:',
		en: 'Order num.:',
		ru: '№ заказа:'
	}

	betreiber: any = {
		it: '',
		de: 'Betreiber / Provider:',
		deDu: 'Betreiber / Provider:',
		en: 'Operator / Provider:',
		ru: 'Оператор / Provider:'
	}
	benutzername: any = {
		it: '',
		de: 'Benutzername:',
		deDu: 'Benutzername:',
		en: 'User name:',
		ru: 'Имя пользователя:'
	}


	// Modal LOCKER-LOGIN-DATA

	lockerLoginData: any = {
		it: '',
		de: 'locker-login-data works!',
		deDu: 'locker-login-data works!',
		en: 'locker-login-data works!',
		ru: 'данные-для-входа работают!'
	}

	// Modal LOCKER-THANKS-YOU


	zugangsdatenAktive: any = {
		it: '',
		de: 'Zugangsdaten &amp; aktive Mieten',
		deDu: 'Zugangsdaten &amp; aktive Mieten',
		en: 'Access data &amp; active rentals',
		ru: 'Доступ к данным &amp; активная аренда'
	}

	wichtigerHinweis: any = {
		it: '',
		de: '<strong>Wichtiger Hinweis:</strong> Bitte nach abgeschlossener Nutzung die "Miete beenden" oder rechtzeitig "verlängern". Andernfalls werden ggf. Verzugsgebühren anfallen.',
		deDu: '<strong>Wichtiger Hinweis:</strong> Bitte nach abgeschlossener Nutzung die "Miete beenden" oder rechtzeitig "verlängern". Andernfalls werden ggf. Verzugsgebühren anfallen.',
		en: "<strong>Important notice:</strong> Please click after use of the box 'end rent' or 'extend' before the rental period ends. If not additional charges will apply.",
		ru: '<strong>Важные заметки:</strong> Пожалуйста, нажмите после использования поля «завершить аренду» или «продлить» до окончания периода аренды. В противном случае взимается дополнительная плата.'
	}
	ladenSieNun1: any = {
		it: '',
		de: "Wie geht's weiter?", // <small>Laden Sie nun bitte <strong>Ihren digitalen Schlüssel</strong> herunter und melden Sie sich mit folgenden Zugangsdaten an. Aktivieren Sie Bluetooth an Ihrem Smartphone, um Ihr Fach mit einem Klick öffnen und schließen zu können.</small>",
		deDu: "Wie geht's weiter?", // <small>Laden Sie nun bitte <strong>Ihren digitalen Schlüssel</strong> herunter und melden Sie sich mit folgenden Zugangsdaten an. Aktivieren Sie Bluetooth an Ihrem Smartphone, um Ihr Fach mit einem Klick öffnen und schließen zu können.</small>",
		en: "What's next?", // <small>Now please download <strong>your digital key</strong> and log in with the following access data. Activate Bluetooth on your smartphone to be able to open and close your box with one click.</small>",
		ru: 'Что дальше?', // <small>Теперь загрузите <strong>ваш цифровой ключ</strong> и войдите в систему, используя следующие данные доступа. Активируйте Bluetooth на своем смартфоне, чтобы иметь возможность открывать и закрывать ячейку одним щелчком мыши.</small>'
	}
	ladenSieNun2: any = {
		it: '',
		de: "Laden Sie nun bitte <strong>Ihren digitalen Schlüssel</strong> herunter und melden Sie sich mit folgenden Zugangsdaten an. Aktivieren Sie Bluetooth an Ihrem Smartphone, um Ihr Fach mit einem Klick öffnen und schließen zu können.",
		deDu: "Laden Sie nun bitte <strong>Ihren digitalen Schlüssel</strong> herunter und melden Sie sich mit folgenden Zugangsdaten an. Aktivieren Sie Bluetooth an Ihrem Smartphone, um Ihr Fach mit einem Klick öffnen und schließen zu können.",
		en: "Now please download <strong>your digital key</strong> and log in with the following access data. Activate Bluetooth on your smartphone to be able to open and close your box with one click.",
		ru: 'Теперь загрузите <strong>ваш цифровой ключ</strong> и войдите в систему, используя следующие данные доступа. Активируйте Bluetooth на своем смартфоне, чтобы иметь возможность открывать и закрывать ячейку одним щелчком мыши.'
	}
	ladenSieNun3: any = {
		it: '',
		de: "Achtung: Falls Sie bereits Kunde bei uns waren, behalten Sie Ihr Passwort, welches Sie früher vergeben haben.",
		deDu: "Achtung: Falls Sie bereits Kunde bei uns waren, behalten Sie Ihr Passwort, welches Sie früher vergeben haben.",
		en: "Attention: If you are already a customer of ours, use the password that you have already assigned.",
		ru: 'Внимание: Если вы уже являетесь нашим клиентом, используйте пароль, который вы уже назначили.'
	}
	jetztHerunterladen: any = {
		it: '',
		de: 'Jetzt herunterladen',
		deDu: 'Jetzt herunterladen',
		en: 'Download now',
		ru: 'Скачать'
	}
	herunterladen: any = {
		it: '',
		de: 'Herunterladen',
		deDu: 'Herunterladen',
		en: 'download',
		ru: 'Скачать'
	}
	ihrDigitaler: any = {
		it: '',
		de: 'Ihr digitaler Schlüssel',
		deDu: 'Ihr digitaler Schlüssel',
		en: 'Your digital key',
		ru: 'Ваш цифровой ключ'
	}

	ihreZugangsdaten: any = {
		it: '',
		de: 'Ihre Zugangsdaten erhalten Sie in Kürze per E-Mail. Bitte prüfen Sie auch ggf. den <strong>SPAM-Ordner</strong>.',
		deDu: 'Ihre Zugangsdaten erhalten Sie in Kürze per E-Mail. Bitte prüfen Sie auch ggf. den <strong>SPAM-Ordner</strong>.',
		en: 'You receive your login data via e-mail shortly. Please also check your <strong>SPAM-folder</strong>.',
		ru: 'В ближайшее время вы получите данные для входа по электронной почте. Пожалуйста, также проверьте <strong>папку СПАМ</strong>.'
	}
	anleitung: any = {
		it: '',
		de: 'Anleitung für die Okey-App',
		deDu: 'Anleitung für die Okey-App',
		en: 'Instructions for the Okey-App',
		ru: 'Инструкция к приложению "Окей"'
	}
	anleitungVideo: any = {
		it: '',
		de: 'Anleitung video',
		deDu: 'Anleitung video',
		en: 'Instruction video',
		ru: 'Видео-инструкция'
	}
	zumKonto: any = {
		it: '',
		de: 'zum Konto',
		deDu: 'zum Konto',
		en: 'To account',
		ru: 'К счету'
	}
	sieHabenAktuell: any = {
		it: '',
		de: 'Sie haben aktuell keine aktiven Mieten',
		deDu: 'Sie haben aktuell keine aktiven Mieten',
		en: 'You currently have no active rentals',
		ru: 'В настоящее время у вас нет активной аренды'
	}
	aufUnserer: any = {
		it: '',
		de: 'Auf unserer Startseite können Sie einen',
		deDu: 'Auf unserer Startseite können Sie einen',
		en: 'You can do one on our home page',
		ru: 'Вы можете сделать это на главной странице'
	}
	neuenMietvorgang: any = {
		it: '',
		de: 'neuen Mietvorgang starten',
		deDu: 'neuen Mietvorgang starten',
		en: 'start a new rental process',
		ru: 'начать новый процесс аренды'
	}
	ihreTemporaren: any = {
		it: '',
		de: 'Ihre temporären Zugangsdaten werden erstellt und demnächst <strong>hier</strong> angezeigt. Bitte haben Sie etwas Geduld. Diese erhalten Sie auch zusätzlich in den nächsten ein-zwei Minuten per E-Mail. Bitte prüfen Sie ggf. den <strong>SPAM-Ordner</strong>',
		deDu: 'Ihre temporären Zugangsdaten werden erstellt und demnächst <strong>hier</strong> angezeigt. Bitte haben Sie etwas Geduld. Diese erhalten Sie auch zusätzlich in den nächsten ein-zwei Minuten per E-Mail. Bitte prüfen Sie ggf. den <strong>SPAM-Ordner</strong>',
		en: 'Your temporary access data will be created and will be displayed <strong>here</strong> soon. Please have a little patience. You will also receive this in the next one or two minutes by e-mail. Please check the <strong>SPAM folder</strong> if necessary',
		ru: 'Ваши временные данные для доступа будут созданы и скоро будут отображаться <strong>здесь</strong>. Пожалуйста, подождите. Вы также получите их в течение следующих пару минут по эл. почте. При необходимости проверьте папку <strong>СПАМ</strong>.'
	}

	// Modal LOCKER-OVERVIEW

	meineDaten: any = {
		it: '',
		de: 'Meine Daten',
		deDu: 'Meine Daten',
		en: 'Personal details',
		ru: 'Персональные данные'
	}

	okeySmartAccess: any = {
		it: '',
		de: 'Okey Smart Access Solutions App',
		deDu: 'Okey Smart Access Solutions App',
		en: 'Okey Smart Access Solutions App',
		ru: 'Приложение Okey Smart Access Solutions'
	}

	fachFreigeben: any = {
		it: '',
		de: 'Fach freigeben',
		deDu: 'Fach freigeben',
		en: 'Release tray',
		ru: 'Выпускной лоток'
	}

	// Tabs ACCOUNT

	meinKonto: any = {
		it: 'Il mio conto',
		de: 'Mein Konto',
		deDu: 'Mein Konto',
		en: 'My account',
		ru: 'Мой счет'
	}

	meineBestellungen: any = {
		it: 'I miei ordini',
		de: 'Meine Bestellungen',
		deDu: 'Meine Bestellungen',
		en: 'My orders',
		ru: 'Мои заказы'
	}

	bereiche: any = {
		it: 'La tua area',
		de: 'Bereiche',
		deDu: 'Bereiche',
		en: 'Area',
		ru: 'Область'
	}
	lieferadressen: any = {
		it: 'Indirizzo di consegna',
		de: 'Lieferadressen',
		deDu: 'Lieferadressen',
		en: 'Delivery addresses',
		ru: 'Адресс доставки'
	}

	fehler89: any = {
		it: 'Errore 89',
		de: 'Fehler 89',
		deDu: 'Fehler 89',
		en: 'Error 89',
		ru: 'Ошибка 89'
	}
	fehlerBeimAbruf: any = {
		it: 'Errore di scaricare i dati dell\'ordine',
		de: 'Fehler beim Abruf der Bestelldaten.',
		deDu: 'Fehler beim Abruf der Bestelldaten.',
		en: 'Error retrieving order data.',
		ru: 'Ошибка при получении данных заказа.'
	}
	fehler59: any = {
		it: 'Errore 59',
		de: 'Fehler 59',
		deDu: 'Fehler 59',
		en: 'Error 59',
		ru: 'Ошибка 59'
	}

	fehler63: any = {
		it: 'Errore 63',
		de: 'Fehler 63',
		deDu: 'Fehler 63',
		en: 'Error 63',
		ru: 'Ошибка 63'
	}

	habenSieDas: any = {
		it: 'Hai gia svuotato e pulito la tua casella?',
		de: 'Haben Sie das Fach schon geleert und gesäubert?',
		deDu: 'Haben Sie das Fach schon geleert und gesäubert?',
		en: 'Have you emptied and cleaned the box yet?',
		ru: 'Вы уже забрали содержимое ячейки?'
	}
	mitEinemKlickAuf: any = {
		it: '',
		de: 'Mit einem Klick auf die Schaltfläche "Ja" bestätigen Sie, dass Sie den gesamten Inhalt aus dem angemieteten Fach entnommen haben, die Tür geschlossen ist und Sie die Miete beenden möchten.',
		deDu: 'Mit einem Klick auf die Schaltfläche "Ja" bestätigen Sie, dass Sie den gesamten Inhalt aus dem angemieteten Fach entnommen haben, die Tür geschlossen ist und Sie die Miete beenden möchten.',
		en: 'By clicking the "Yes" button, you confirm that you have taken all the contents from the rented box, the door is closed and you want to end the rental.',
		ru: 'Нажимая кнопку «Да», вы подтверждаете, что забрали все содержимое из арендованной ячейки, дверь закрыта и хотите завершить аренду.'
	}
	warenkorbUeberschreiben: any = {
		it: '',
		de: 'Warenkorb überschreiben?',
		deDu: 'Warenkorb überschreiben?',
		en: 'Overwrite shopping cart?',
		ru: 'Переписать корзину?'
	}
	warenkorbUeberschreibenText: any = {
		it: '',
		de: 'Sie haben bereits mind. einen Artikel im Warenkorb. Eine Verlängerung ist jedoch nur einzeln möglich. Möchten Sie die Artikel im Warenkorb entfernen und mit der Nachzahlung fortsetzen?',
		deDu: 'Du hast bereits mind. einen Artikel im Warenkorb. Eine Verlängerung ist jedoch nur einzeln möglich. Möchtest du die Artikel im Warenkorb entfernen und mit der Nachzahlung fortsetzen?',
		en: 'You already have at least one item in your shopping cart. However, a renewal is only possible individually. Do you want to remove the items in the shopping cart and continue with the additional payment?',
		ru: 'У вас уже есть товар в корзине. Однако продление возможно только в индивидуальном порядке. Вы хотите удалить товары из корзины и продолжить доплату?'
	}

	fehler109: any = {
		it: 'Errore 109',
		de: 'Fehler 109',
		deDu: 'Fehler 109',
		en: 'Error 109',
		ru: 'Ошибка 109'
	}

	downloadFehlgeschlagen: any = {
		it: 'Download non andato a buon fine',
		de: 'Download fehlgeschlagen. Bitte versuchen Sie es erneut.',
		deDu: 'Download fehlgeschlagen. Bitte versuchen Sie es erneut.',
		en: 'Failed to download. Please try again.',
		ru: 'Не удалось загрузить. Пожалуйста, попробуйте еще раз.'
	}

	// Tabs TABS


	menu: any = {
		it: 'Menu',
		de: 'Menü',
		deDu: 'Menü',
		en: 'Menu',
		ru: 'Меню'
	}

	// Shared BASKET
	esBefindenSichKeinArtikelInIhremWarenkorb: any = {
		it: 'Non ci sono articoli nel tuo carrello',
		de: 'Es befinden sich keine Artikel in Ihrem Warenkorb.',
		deDu: 'Es befinden sich keine Artikel in Ihrem Warenkorb.',
		en: 'There are no items in your shopping cart.',
		ru: 'В вашей корзине нет товаров.',
	}
	benutzerkontoVorhanden: any = {
		it: 'Account presente',
		de: 'Benutzerkonto vorhanden',
		deDu: 'Benutzerkonto vorhanden',
		en: 'User account available',
		ru: 'Учетная запись доступна'
	}
	wirHabenIhnen: any = {
		it: '',
		de: 'Wir haben Ihnen einen temporären Anmeldelink gesendet, mit dem Sie sich in Ihrem Benutzerkonto anmelden und die Bestellung fortsetzen können.',
		deDu: 'Wir haben Ihnen einen temporären Anmeldelink gesendet, mit dem Sie sich in Ihrem Benutzerkonto anmelden und die Bestellung fortsetzen können.',
		en: 'We have sent you a temporary login link that you can use to log into your user account and continue with the order.',
		ru: 'Мы отправили вам временную ссылку для входа, которую вы можете использовать чтобы войти в свою учетную запись и продолжить оформление заказа.'
	}
	anmeldenVerifizieren: any = {
		it: 'Accedere/verificare',
		de: 'Anmelden / Verifizieren',
		deDu: 'Anmelden / Verifizieren',
		en: 'Login / Verify',
		ru: 'Войти / Подтвердить'
	}
	wirSendenIhnen: any = {
		it: '',
		de: 'Wir senden Ihnen einen temporären Anmeldelink, der Ihnen Zugriff auf Ihr Kundenkonto gewährt.',
		deDu: 'Wir senden Ihnen einen temporären Anmeldelink, der Ihnen Zugriff auf Ihr Kundenkonto gewährt.',
		en: 'We will send you a temporary login link that gives you access to your customer account.',
		ru: 'Мы вышлем вам временную ссылку для входа, которая даст вам доступ к вашей учетной записи.'
	}
	eMailAdresseEingeben: any = {
		it: '',
		de: 'E-Mail Adresse eingeben ...',
		deDu: 'E-Mail Adresse eingeben ...',
		en: 'Enter email address...',
		ru: 'Введите адрес эл. почты...'
	}
	aktionErfolgreich: any = {
		it: '',
		de: '<strong>Aktion erfolgreich!</strong><br />Sie wurden erfolgreich vom System abgemeldet.',
		deDu: '<strong>Aktion erfolgreich!</strong><br />Sie wurden erfolgreich vom System abgemeldet.',
		en: '<strong>Action successful!</strong><br />You have been successfully logged out of the system.',
		ru: '<strong>Действие выполнено успешно!</strong><br />Вы успешно вышли из системы.'
	}
	mochtenSieSich: any = {
		it: '',
		de: 'Möchten Sie sich vom System abmelden? Sie können sich zukünftig ausschließlich über Ihre registrierte E-Mail erneut anmelden.',
		deDu: 'Möchten Sie sich vom System abmelden? Sie können sich zukünftig ausschließlich über Ihre registrierte E-Mail erneut anmelden.',
		en: 'Do you want to log out of the system? In the future, you can only register again using your registered e-mail.',
		ru: 'Вы хотите выйти из системы? В дальнейшем вы сможете повторно зарегистрироваться только с зарегистрированным адресом эл. почты.'
	}
	warenkorbWirklich: any = {
		it: '',
		de: 'Warenkorb wirklich leeren?',
		deDu: 'Warenkorb wirklich leeren?',
		en: 'Really empty shopping cart?',
		ru: 'Корзина реально пустая?'
	}
	aktionFehlgeschlagenDer: any = {
		it: '',
		de: '<strong>Aktion fehlgeschlagen</strong><br>Der Artikel konnte nicht zum Warenkorb hinzugefügt werden. Bitte versuchen Sie es erneut.',
		deDu: '<strong>Aktion fehlgeschlagen</strong><br>Der Artikel konnte nicht zum Warenkorb hinzugefügt werden. Bitte versuchen Sie es erneut.',
		en: '<strong>Action failed</strong><br>The item could not be added to the shopping cart. Please try again.',
		ru: '<strong>Не удалось выполнить действие</strong><br>Не удалось добавить товар в корзину. Пожалуйста, попробуйте еще раз.'
	}
	aktionFehlgeschlagenBitte: any = {
		it: '',
		de: '<strong>Aktion fehlgeschlagen</strong><br>Bitte geben Sie eine gültige E-Mail Adresse ein.',
		deDu: '<strong>Aktion fehlgeschlagen</strong><br>Bitte geben Sie eine gültige E-Mail Adresse ein.',
		en: '<strong>Action failed</strong><br>Please enter a valid email address.',
		ru: '<strong>Не удалось выполнить действие</strong><br>Пожалуйста, введите рабочий адрес эл. почты.'
	}
	anmeldelinkWurdeGesendet: any = {
		it: '',
		de: '<strong>Anmeldelink wurde gesendet</strong><br />Bitte prüfen Sie den Posteingang und Spamordner Ihres E-Mail Postfachs.',
		deDu: '<strong>Anmeldelink wurde gesendet</strong><br />Bitte prüfen Sie den Posteingang und Spamordner Ihres E-Mail Postfachs.',
		en: '<strong>Registration link has been sent</strong><br />Please check the inbox and spam folder of your email inbox.',
		ru: '<strong>Ссылка для регистрации отправлена</strong><br />Пожалуйста, проверьте папку "Входящие" и "Спам" вашей эл. почты.'
	}
	aktionFehlgeschlagenDie: any = {
		it: '',
		de: '<strong>Aktion fehlgeschlagen</strong><br>Die eingegebene E-Mail Adresse wurde nicht in unserem System gefunden.',
		deDu: '<strong>Aktion fehlgeschlagen</strong><br>Die eingegebene E-Mail Adresse wurde nicht in unserem System gefunden.',
		en: '<strong>Action failed</strong><br>The email address you entered was not found in our system.',
		ru: '<strong>Не удалось выполнить действие</strong><br>Введенный вами адрес электронной почты не найден в нашей системе.'
	}
	loschen: any = {
		it: '',
		de: 'Delete',
		deDu: 'Delete',
		en: 'Delete',
		ru: 'Удалить'
	}
	productsettings: any = {
		it: '',
		de: 'Produkteinstellungen',
		deDu: 'Produkteinstellungen',
		en: 'Product settings',
		ru: 'Настройки товара'
	}
	description: any = {
		it: '',
		de: 'Beschreibung',
		deDu: 'Beschreibung',
		en: 'Description',
		ru: 'Описание'
	}
	useprice: any = {
		it: '',
		de: 'Preis verwenden',
		deDu: 'Preis verwenden',
		en: 'Use price',
		ru: 'Использовать цену'
	}
	zusatzstoffeKopieren: any = {
		it: '',
		de: 'Zusatzstoffe kopieren',
		deDu: 'Zusatzstoffe kopieren',
		en: 'Copy additives',
		ru: 'Копирование добавок'
	}
	additive: any = {
		it: '',
		de: 'Additive',
		deDu: 'Additive',
		en: 'Additives',
		ru: 'Добавки'
	}
	possibleNumber: any = {
		it: '',
		de: 'Mögliche Anzahl von Zusatzstoffen zu diesem Produkt.',
		deDu: 'Mögliche Anzahl von Zusatzstoffen zu diesem Produkt.',
		en: 'Possible number of additives to this product.',
		ru: 'Возможное количество добавок к этому товару.'
	}
	ermoglichenSie: any = {
		it: '',
		de: 'Ermöglichen Sie die Möglichkeit, dieselben Zusatzstoffe hinzuzufügen',
		deDu: 'Ermöglichen Sie die Möglichkeit, dieselben Zusatzstoffe hinzuzufügen',
		en: 'Allow the ability to add the same additives',
		ru: 'Разрешить возможность добавления одинаковых добавок'
	}
	additivedPrice: any = {
		it: '',
		de: 'Gibt es einen Preis für den Zuschlag?',
		deDu: 'Gibt es einen Preis für den Zuschlag?',
		en: 'Is there a price for the supplement?',
		ru: 'Есть ли цена у добавки?'
	}
	erganzungHinzufugen: any = {
		it: '',
		de: 'Ergänzung hinzufügen',
		deDu: 'Ergänzung hinzufügen',
		en: 'Add complement',
		ru: 'Добавить дополнение'
	}
	karten: any = {
		it: '',
		de: 'Karten',
		deDu: 'Karten',
		en: 'Cards',
		ru: 'Карточки'
	}
	leisteMitMehreren: any = {
		it: '',
		de: 'Leiste mit mehreren Boxen/Bildern neben- und untereinander mit autom. Breitenanpassung.',
		deDu: 'Leiste mit mehreren Boxen/Bildern neben- und untereinander mit autom. Breitenanpassung.',
		en: 'Bar with several boxes/images next to and below each other with autom. width adjustment.',
		ru: 'Панель с несколькими блоками/картинками друг возле друга с авто. регулировкой ширины.'
	}
	textHtml: any = {
		it: '',
		de: 'Text / HTML',
		deDu: 'Text / HTML',
		en: 'Text / HTML',
		ru: 'Текст / HTML'
	}
	idealFurLangere: any = {
		it: '',
		de: 'Ideal für längere Texte mit Beschreibung oder auch eigene HTML-Inhalte.',
		deDu: 'Ideal für längere Texte mit Beschreibung oder auch eigene HTML-Inhalte.',
		en: 'Ideal for longer texts with descriptions or your own HTML content.',
		ru: 'Идеально подходит для длинных текстов с описаниями или собственного HTML-контента.'
	}
	bildText: any = {
		it: '',
		de: 'Bild / Text',
		deDu: 'Bild / Text',
		en: 'Image / text',
		ru: 'Картинка/текст'
	}
	zweiGeteilteKarte: any = {
		it: '',
		de: 'Zwei-geteilte Karte mit positionierbarem Bild und Text.',
		deDu: 'Zwei-geteilte Karte mit positionierbarem Bild und Text.',
		en: 'Two-part card with positionable image and text.',
		ru: 'Карточка из двух частей с позиционируемым изображением и текстом.'
	}
	symbolkarten: any = {
		it: '',
		de: 'Symbolkarten',
		deDu: 'Symbolkarten',
		en: 'Symbol cards',
		ru: 'Карточки с символами'
	}
	leisteMitMehrerenIcons: any = {
		it: '',
		de: 'Leiste mit mehreren Boxen/Icons neben- und untereinander mit autom. Breitenanpassung.',
		deDu: 'Leiste mit mehreren Boxen/Icons neben- und untereinander mit autom. Breitenanpassung.',
		en: 'Bar with several boxes/icons next to and below each other with autom. width adjustment.',
		ru: 'Панель с несколькими блоками/значками друг возле друга с авто. регулировкой ширины.'
	}
	slideshow: any = {
		it: '',
		de: 'Slideshow',
		deDu: 'Slideshow',
		en: 'Slideshow',
		ru: 'Слайдер'
	}
	eineSlideshow: any = {
		it: '',
		de: 'Eine Slideshow mit mehreren verlinkbaren Slides, die automatisch durchscrollen.',
		deDu: 'Eine Slideshow mit mehreren verlinkbaren Slides, die automatisch durchscrollen.',
		en: 'A slideshow with multiple linkable slides that scroll through automatically.',
		ru: 'Слайдер с несколькими слайдами и авто. пролистыванием.'
	}
	aktionsbanner: any = {
		it: '',
		de: 'Aktionsbanner',
		deDu: 'Aktionsbanner',
		en: 'Action banner',
		ru: 'Баннер действия'
	}
	grobflachigePromotion: any = {
		it: '',
		de: 'Großflächige Promotion mit "call-to-action" Button für Sonderangebote oder Aktionen.',
		deDu: 'Großflächige Promotion mit "call-to-action" Button für Sonderangebote oder Aktionen.',
		en: 'Large-scale promotion with "call-to-action" button for special offers or campaigns.',
		ru: 'Масштабное продвижение с помощью кнопки «призыв к действию» для специальных предложений или акций.'
	}
	kategoriebaumMit: any = {
		it: '',
		de: 'Kategoriebaum mit Artikeln und Suchfunktion, sowie verschiedene Ansichten und Filtern.',
		deDu: 'Kategoriebaum mit Artikeln und Suchfunktion, sowie verschiedene Ansichten und Filtern.',
		en: 'Category tree with articles and search function, as well as different views and filters.',
		ru: 'Категорий со контентом  и функцией поиска, а также различные представления и фильтры.'
	}
	faqS: any = {
		it: 'FAQ\'s',
		de: 'FAQ\'s',
		deDu: 'FAQ\'s',
		en: 'FAQ\'s',
		ru: 'ЧЗВ'
	}
	sammlungVonFragen: any = {
		it: '',
		de: 'Sammlung von Fragen und Antworten mit verschiedenen Hashtags.',
		deDu: 'Sammlung von Fragen und Antworten mit verschiedenen Hashtags.',
		en: 'Collection of questions and answers with different hashtags.',
		ru: 'Сборник вопросов и ответов с разными хэштегами.'
	}
	newsBlog: any = {
		it: '',
		de: 'News / Blog',
		deDu: 'News / Blog',
		en: 'News / Blog',
		ru: 'Новости / Блог'
	}
	bogsSeiteMit: any = {
		it: '',
		de: 'Bogs Seite mit Filtermöglichkeiten für News (Vorschau- und Detailansicht)',
		deDu: 'Bogs Seite mit Filtermöglichkeiten für News (Vorschau- und Detailansicht)',
		en: 'Blog page with filter options for news (preview and detailed view)',
		ru: 'Страница блог с параметрами фильтрации новостей (предварительный просмотр и подробный просмотр)'
	}
	kontaktformular: any = {
		it: '',
		de: 'Kontaktformular',
		deDu: 'Kontaktformular',
		en: 'Contact form',
		ru: 'Контактная форма'
	}
	vielseitigKonfigurierbares: any = {
		it: '',
		de: 'Vielseitig konfigurierbares Kontaktformular mit Google Maps Standortkarte.',
		deDu: 'Vielseitig konfigurierbares Kontaktformular mit Google Maps Standortkarte.',
		en: 'Versatile configurable contact form with Google Maps location map.',
		ru: 'Универсальная настраиваемая контактная форма с картой местоположения Google Maps.'
	}
	newsletterFormular: any = {
		it: '',
		de: 'Newsletter Formular',
		deDu: 'Newsletter Formular',
		en: 'Newsletter form',
		ru: 'Форма рассылки'
	}
	newsletterBanner: any = {
		it: '',
		de: 'Newsletter Banner mit "call-to-action" Button im Abo-Formular.',
		deDu: 'Newsletter Banner mit "call-to-action" Button im Abo-Formular.',
		en: 'Newsletter banner with "call-to-action" button in the subscription form.',
		ru: 'Баннер рассылки с кнопкой «призыв к действию» в форме подписки.'
	}
	einBlockInDen: any = {
		it: '',
		de: 'Ein Block, in den Sie ein Video von Youtube und einen Beschreibungstext einfügen können.',
		deDu: 'Ein Block, in den Sie ein Video von Youtube und einen Beschreibungstext einfügen können.',
		en: 'A block where you can put a video from Youtube and some description text.',
		ru: 'Блок, куда можно поместить видео с Youtube и текст описания.'
	}

	imagetype: any = {
		it: '',
		de: 'Bildseitenverhältnis',
		deDu: 'Bildseitenverhältnis',
		en: 'Image aspect ratio',
		ru: 'Пропорции изображения'
	}
	imageProportion: any = {
		it: '',
		de: 'Ursprüngliche Proportionen?',
		deDu: 'Ursprüngliche Proportionen?',
		en: 'Original proportions?',
		ru: 'Оригинальные пропорции?'
	}
	urlSeo: any = {
		it: '',
		de: 'URL/SEO',
		deDu: 'URL/SEO',
		en: 'URL/SEO',
		ru: 'Ссылка'
	}
	metaKeywords: any = {
		it: '',
		de: 'Meta Keywords',
		deDu: 'Meta Keywords',
		en: 'Meta Keywords',
		ru: 'Мета ключевые слова'
	}
	metaBeschreibung: any = {
		it: '',
		de: 'Meta Beschreibung',
		deDu: 'Meta Beschreibung',
		en: 'Meta description',
		ru: 'Мета описание'
	}
	sofort: any = {
		it: '',
		de: 'Sofort',
		deDu: 'Sofort',
		en: 'Right away',
		ru: 'Сейчас'
	}
	spateren: any = {
		it: '',
		de: 'Späteren',
		deDu: 'Späteren',
		en: 'Later',
		ru: 'На потом'
	}
	anWenMochten: any = {
		it: '',
		de: 'An wen möchten Sie senden?',
		deDu: 'An wen möchten Sie senden?',
		en: 'Who do you want to send to?',
		ru: 'Кому вы хотите отправить?'
	}
	zustimmungZumNewsletter: any = {
		it: '',
		de: 'Zustimmung zum Newsletter',
		deDu: 'Zustimmung zum Newsletter',
		en: 'Consent to the newsletter',
		ru: 'Согласие на рассылку'
	}
	manuell: any = {
		it: '',
		de: 'Manuell',
		deDu: 'Manuell',
		en: 'Manually',
		ru: 'Вручную'
	}
	wieMochten: any = {
		it: '',
		de: 'Wie möchten Sie versenden?',
		deDu: 'Wie möchten Sie versenden?',
		en: 'How would you like to ship?',
		ru: 'Как бы вы хотели отправить?'
	}
	push: any = {
		it: '',
		de: 'Push',
		deDu: 'Push',
		en: 'Push',
		ru: 'Уведомления'
	}
	sendenEinesAngebots: any = {
		it: '',
		de: 'Senden eines Angebots',
		deDu: 'Senden eines Angebots',
		en: 'Sending an offer',
		ru: 'Отправка предложения'
	}
	manuellAuswahlen: any = {
		it: '',
		de: 'Manuell auswählen',
		deDu: 'Manuell auswählen',
		en: 'Select manually',
		ru: 'Выбрать вручную'
	}
	ausgewahltAnzeigen: any = {
		it: '',
		de: 'Ausgewählt anzeigen',
		deDu: 'Ausgewählt anzeigen',
		en: 'Show Selected',
		ru: 'Показать выбранное'
	}
	sendezeitDerNachricht: any = {
		it: '',
		de: 'Sendezeit der Nachricht',
		deDu: 'Sendezeit der Nachricht',
		en: 'Send time of the message',
		ru: 'Время отправки сообщения'
	}
	durchKlicken: any = {
		it: '',
		de: 'Durch Klicken auf die Schaltfläche "Senden" wird keine E-Mail an alle Benutzer gesendet',
		deDu: 'Durch Klicken auf die Schaltfläche "Senden" wird keine E-Mail an alle Benutzer gesendet',
		en: 'Clicking the send button does not send email to all users',
		ru: 'Нажатие кнопки отправки не отправляет электронную почту всем пользователям'
	}
	dieNachricht: any = {
		it: '',
		de: 'Die Nachricht wird gesendet',
		deDu: 'Die Nachricht wird gesendet',
		en: 'The message is sent',
		ru: 'Сообщение отправлено'
	}
	nachfullen: any = {
		it: '',
		de: 'Nachfüllen',
		deDu: 'Nachfüllen',
		en: 'Refilling',
		ru: 'Пополнить'
	}
	Kaufen: any = {
		it: '',
		de: 'Kaufen',
		deDu: 'Kaufen',
		en: 'Buy',
		ru: 'Купить'
	}
	Kurznachricht: any = {
		it: '',
		de: 'Kurznachricht',
		deDu: 'Kurznachricht',
		en: 'Short message',
		ru: 'Короткое сообщение'
	}
	pushTitel: any = {
		it: '',
		de: 'Push titel / E-Mail Betreff',
		deDu: 'Push titel / E-Mail Betreff',
		en: 'Push title / Email subject',
		ru: 'Заголовок сообщения / тема письма'
	}
	pushNachricht: any = {
		it: '',
		de: 'Push-Nachricht',
		deDu: 'Push-Nachricht',
		en: 'Push-Message',
		ru: 'Отправить сообщение'
	}
	vorhandeneExtras: any = {
		it: '',
		de: 'Vorhandene Extras nutzen',
		deDu: 'Vorhandene Extras nutzen',
		en: 'Use existing extras',
		ru: 'Используйте существующие дополнения'
	}
	neueKategorieErstellen: any = {
		it: '',
		de: 'Neue Kategorie erstellen',
		deDu: 'Neue Kategorie erstellen',
		en: 'Create new category',
		ru: 'Создать новую категорию'
	}
	bildLoschen: any = {
		it: '',
		de: 'Bild löschen',
		deDu: 'Bild löschen',
		en: 'Delete image',
		ru: 'Удалить изображение'
	}

	vorhExtrasNutzen: any = {
		it: '',
		de: 'Vorh. Extras nutzen',
		deDu: 'Vorh. Extras nutzen',
		en: 'Prev. use extras',
		ru: 'Пред. использовать дополнения'
	}
	extrasErstellen: any = {
		it: '',
		de: 'Extras erstellen',
		deDu: 'Extras erstellen',
		en: 'Create extras',
		ru: 'Создать добавку'
	}
	ihrKommentar: any = {
		it: 'Il tuo messaggio',
		de: 'Ihr Kommentar / Wunsch ...',
		deDu: 'Ihr Kommentar / Wunsch ...',
		en: 'Your comment / wish ...',
		ru: 'Ваш комментарий / пожелание ...'
	}

	dayLong1: any = {
		it: '',
		de: 'Montag',
		deDu: 'Montag',
		en: 'Monday',
		ru: 'Понедельник'
	}
	dayLong2: any = {
		it: '',
		de: 'Dienstag',
		deDu: 'Dienstag',
		en: 'Tuesday',
		ru: 'Вторник'
	}
	dayLong3: any = {
		it: '',
		de: 'Mittwoch',
		deDu: 'Mittwoch',
		en: 'Wednesday',
		ru: 'Среда'
	}
	dayLong4: any = {
		it: '',
		de: 'Donnerstag',
		deDu: 'Donnerstag',
		en: 'Thursday',
		ru: 'Четверг'
	}
	dayLong5: any = {
		it: '',
		de: 'Freitag',
		deDu: 'Freitag',
		en: 'Friday',
		ru: 'Пятница'
	}
	dayLong6: any = {
		it: '',
		de: 'Samstag',
		deDu: 'Samstag',
		en: 'Saturday',
		ru: 'Суббота'
	}
	dayLong7: any = {
		it: '',
		de: 'Sonntag',
		deDu: 'Sonntag',
		en: 'Sunday',
		ru: 'Воскресенье'
	}
	'Montag': any = {
		it: '',
		de: 'Montag',
		deDu: 'Montag',
		en: 'Monday',
		ru: 'Понедельник'
	}
	'Dienstag': any = {
		it: '',
		de: 'Dienstag',
		deDu: 'Dienstag',
		en: 'Tuesday',
		ru: 'Вторник'
	}
	'Mittwoch': any = {
		it: '',
		de: 'Mittwoch',
		deDu: 'Mittwoch',
		en: 'Wednesday',
		ru: 'Среда'
	}
	'Donnerstag': any = {
		it: '',
		de: 'Donnerstag',
		deDu: 'Donnerstag',
		en: 'Thursday',
		ru: 'Четверг'
	}
	'Freitag': any = {
		it: '',
		de: 'Freitag',
		deDu: 'Freitag',
		en: 'Friday',
		ru: 'Пятница'
	}
	'Samstag': any = {
		it: '',
		de: 'Samstag',
		deDu: 'Samstag',
		en: 'Saturday',
		ru: 'Суббота'
	}
	'Sonntag': any = {
		it: '',
		de: 'Sonntag',
		deDu: 'Sonntag',
		en: 'Sunday',
		ru: 'Воскресенье'
	}
	'Geöffnet': any = {
		it: '',
		de: 'Opened',
		deDu: 'Opened',
		en: 'Opened',
		ru: 'Открыто'
	}
	'Geschlossen': any = {
		it: '',
		de: 'Closed',
		deDu: 'Closed',
		en: 'Closed',
		ru: 'Закрыто'
	}
	offnungszeiten: any = {
		it: '',
		de: 'Opening hours',
		deDu: 'Opening hours',
		en: 'Opening hours',
		ru: 'Часы работы'
	}
	offnungszeitenFeiertage: any = {
		it: '',
		de: 'Öffnungszeiten, Feiertage und Countdown in einer Statuszeile anzeigen.',
		deDu: 'Öffnungszeiten, Feiertage und Countdown in einer Statuszeile anzeigen.',
		en: 'Show opening hours, holidays and countdown in a status bar.',
		ru: 'Показать часы работы, праздничные дни и обратный отсчет в статусной строке'
	}
	eroffnungIn: any = {
		it: '',
		de: 'Wir öffnen in',
		deDu: 'Wir öffnen in',
		en: 'Will open in',
		ru: 'Откроемся через'
	}
	wirOffnen: any = {
		it: '',
		de: 'Wir öffnen in',
		deDu: 'Wir öffnen in',
		en: 'We open in',
		ru: 'Откроемся через'
	}
	durchbrechen: any = {
		it: '',
		de: 'Pause in',
		deDu: 'Pause in',
		en: 'Break in',
		ru: 'Перерыв через'
	}
	wirSchlieben: any = {
		it: '',
		de: 'Wir schließen in',
		deDu: 'Wir schließen in',
		en: 'We will close in',
		ru: 'Закроемся через'
	}
	bereitsGeschlossen: any = {
		it: '',
		de: 'Bereits geschlossen',
		deDu: 'Bereits geschlossen',
		en: 'Already closed',
		ru: 'Уже закрыто'
	}
	limitedItems: any = {
		it: '',
		de: 'Begrenzte Artikel',
		deDu: 'Begrenzte Artikel',
		en: 'Limited items',
		ru: 'Лимит элементов'
	}
	limited: any = {
		it: '',
		de: 'Items per page',
		deDu: 'Items per page',
		en: 'Items per page',
		ru: 'Лимит'
	}
	sortBy: any = {
		it: '',
		de: 'Sort by',
		deDu: 'Sort by',
		en: 'Sort by',
		ru: 'Сортировать по'
	}
	sortAscending: any = {
		it: '',
		de: 'Sort ascending',
		deDu: 'Sort ascending',
		en: 'Sort ascending',
		ru: 'По возрастанию'
	}
	sortDescending: any = {
		it: '',
		de: 'Sort descending',
		deDu: 'Sort descending',
		en: 'Sort descending',
		ru: 'По убыванию'
	}
	managementOfAllLockers: any = {
		it: 'Management of all lockers',
		de: 'Management of all lockers',
		deDu: 'Management of all lockers',
		en: 'Management of all lockers',
		ru: 'Управление всеми шкафчиками'
	}
	showActiveOrders: any = {
		it: 'Mostra gli ordini attivi',
		de: 'Zeige aktive Bestellungen',
		deDu: 'Zeige aktive Bestellungen',
		en: 'Show active orders',
		ru: 'Показать активные заказы'
	}
	searchOfDescription: any = {
		it: 'Cerca per descrizione',
		de: 'Suche nach Beschreibung',
		deDu: 'Suche nach Beschreibung',
		en: 'Search by description',
		ru: 'Поиск по описанию'
	}
	//Domains page

	domains: any = {
		it: '',
		de: 'Domänen',
		deDu: 'Domänen',
		en: 'Domains',
		ru: ''
	}
	locations: any = {
		it: '',
		de: 'Locations',
		deDu: 'Locations',
		en: 'Locations',
		ru: ''
	}
	franchisees: any = {
		it: '',
		de: 'Franchisees',
		deDu: 'Franchisees',
		en: 'Franchisees',
		ru: ''
	}
	template: any = {
		it: '',
		de: 'Template',
		deDu: 'Template',
		en: 'Template',
		ru: ''
	}
	hinzufugen: any = {
		it: '',
		de: 'Add',
		deDu: 'Add',
		en: 'Add',
		ru: ''
	}
	urlEingeben: any = {
		it: '',
		de: 'URL eingeben...',
		deDu: 'URL eingeben...',
		en: 'Enter url...',
		ru: ''
	}
	nichtsPasste: any = {
		it: '',
		de: 'Nichts passte zu Ihrer Anfrage...',
		deDu: 'Nichts passte zu Ihrer Anfrage...',
		en: 'Nothing matched your request...',
		ru: ''
	}
	bitteDomain: any = {
		it: '',
		de: 'Bitte Domain hinzufügen!',
		deDu: 'Bitte Domain hinzufügen!',
		en: 'Please add domain!',
		ru: ''
	}
	domainVerbunden: any = {
		it: '',
		de: 'Domain verbunden',
		deDu: 'Domain verbunden',
		en: 'Domain connected',
		ru: ''
	}
	bitteDomainVerbinden: any = {
		it: '',
		de: 'Bitte Domain verbinden!',
		deDu: 'Bitte Domain verbinden!',
		en: 'Please connect Domain!',
		ru: ''
	}

	//locations page
	opening: any = {
		it: '',
		de: 'Öffnung',
		deDu: 'Öffnung',
		en: 'Opening',
		ru: ''
	}
	offnungszeitenHinweis: any = {
		it: '',
		de: 'Skip Opening hours Pop-Up',
		deDu: 'Skip Opening hours Pop-Up',
		en: 'Opening hours notice can be skipped',
		ru: 'Уведомление о графике работы можно пропустить'
	}

	// monitoring / terminals page

	restartScan: any = {
		it: '',
		de: 'Start lock scan',
		deDu: 'Start lock scan',
		en: 'Start lock scan',
		ru: ''
	}
	restartService: any = {
		it: '',
		de: 'Restart complete lock scan',
		deDu: 'Restart complete lock scan',
		en: 'Restart complete lock scan',
		ru: ''
	}
	refreshService: any = {
		it: '',
		de:   'Info aktualisieren',
		deDu: 'Info aktualisieren',
		en: 'Refresh line',
		ru: ''
	}

	times: any = {
		it: '',
		de:   'Access',
		deDu: 'Access',
		en: 'Hours',
		ru: ''
	}
	prices: any = {
		it: '',
		de:   'Prices',
		deDu: 'Prices',
		en: 'Prices',
		ru: ''
	}
	vouchers: any = {
		it: '',
		de:   'Vouchers',
		deDu: 'Vouchers',
		en: 'Coupons',
		ru: ''
	}

	schloesser: any = {
		it: '',
		de:   'Locks',
		deDu: 'Locks',
		en: 'Locks',
		ru: ''
	}

	datenBearbeiten: any = {
		it: '',
		de: 'Daten bearbeiten',
		deDu: 'Daten bearbeiten',
		en: 'Edit data',
		ru: 'Редактировать данные'
	}
	company: any = {
		it: 'Company',
		de: 'Unternehmenscode',
		deDu: 'Unternehmenscode',
		en: 'Company',
		ru: 'Company'
	}
	site: any = {
		it: 'Site',
		de: 'Seite',
		deDu: 'Seite',
		en: 'Site',
		ru: 'Site'
	}
	domain: any = {
		it: 'Domain',
		de: 'Domain',
		deDu: 'Domain',
		en: 'Domain',
		ru: 'Домен'
	}
	locationsGroups: any = {
		it: 'Ubicazione gruppi',
		de: 'Map Configuration',
		deDu: 'Map Configuration',
		en: 'Map Configuration',
		ru: 'Группы локаций'
	}
	timezones: any = {
		it: 'Fusi orari',
		de: 'Zeitzonen',
		deDu: 'Zeitzonen',
		en: 'Timezones',
		ru: 'Часовые пояса'
	}
	timezone: any = {
		it: 'Fuso orario',
		de: 'Zeitzone',
		deDu: 'Zeitzone',
		en: 'Timezone',
		ru: 'Часовой пояс'
	}
	newTimezone: any = {
		it: 'Nuovo fuso orario',
		de: 'Neue Zeitzone',
		deDu: 'Neue Zeitzone',
		en: 'New Timezone',
		ru: 'Новый часовой пояс'
	}
	managementListTimezone: any = {
		it: 'Elenco gestione fusi orari',
		de: 'Verwaltungsliste Zeitzonen',
		deDu: 'Verwaltungsliste Zeitzonen',
		en: 'Management list timezone',
		ru: 'Список управления часовыми поясами'
	}
	keyLabel: any = {
		it: 'Key',
		de: 'Schluessel',
		deDu: 'Schluessel',
		en: 'Key',
		ru: 'Ключ'
	}
	momentZone: any = {
		it: 'Zona Moment',
		de: 'Moment-Zone',
		deDu: 'Moment-Zone',
		en: 'Moment Zone',
		ru: 'Зона Moment'
	}
	displayName: any = {
		it: 'Nome visualizzato',
		de: 'Anzeigename',
		deDu: 'Anzeigename',
		en: 'Display name',
		ru: 'Отображаемое имя'
	}
	sortOrder: any = {
		it: 'Ordine',
		de: 'Sortierung',
		deDu: 'Sortierung',
		en: 'Sort order',
		ru: 'Порядок сортировки'
	}
	actionLabel: any = {
		it: 'Azione',
		de: 'Aktion',
		deDu: 'Aktion',
		en: 'Action',
		ru: 'Действие'
	}
	addTimezoneButton: any = {
		it: 'Aggiungi',
		de: 'Hinzufuegen',
		deDu: 'Hinzufuegen',
		en: 'Add',
		ru: 'Добавить'
	}
	timezoneSearchPlaceholder: any = {
		it: 'Cerca fuso orario...',
		de: 'Zeitzone suchen...',
		deDu: 'Zeitzone suchen...',
		en: 'Search timezone...',
		ru: 'Поиск часового пояса...'
	}
	timezoneSaved: any = {
		it: 'Fuso orario salvato',
		de: 'Zeitzone gespeichert',
		deDu: 'Zeitzone gespeichert',
		en: 'Timezone saved',
		ru: 'Часовой пояс сохранен'
	}
	timezoneLoadFailed: any = {
		it: 'Fusi orari non possono essere caricati.',
		de: 'Zeitzonen konnten nicht geladen werden.',
		deDu: 'Zeitzonen konnten nicht geladen werden.',
		en: 'Timezones could not be loaded.',
		ru: 'Часовые пояса не удалось загрузить.'
	}
	timezoneSaveFailed: any = {
		it: 'Fuso orario non puo essere salvato.',
		de: 'Zeitzone konnte nicht gespeichert werden.',
		deDu: 'Zeitzone konnte nicht gespeichert werden.',
		en: 'Timezone could not be saved.',
		ru: 'Часовой пояс не удалось сохранить.'
	}
	timezoneInUseHeader: any = {
		it: 'Fuso orario in uso',
		de: 'Zeitzone wird verwendet',
		deDu: 'Zeitzone wird verwendet',
		en: 'Timezone in use',
		ru: 'Часовой пояс используется'
	}
	timezoneInUseMessage: any = {
		it: 'Questo fuso orario e ancora usato da {count} sede/i.',
		de: 'Diese Zeitzone wird aktuell von {count} Standort(en) verwendet.',
		deDu: 'Diese Zeitzone wird aktuell von {count} Standort(en) verwendet.',
		en: 'This timezone is still used by {count} location(s).',
		ru: 'Этот часовой пояс все еще используется в {count} локации(ях).'
	}
	locationTimeZoneDescription: any = {
		it: 'Fuso orario della sede',
		de: 'Zeitzone des Standorts',
		deDu: 'Zeitzone des Standorts',
		en: 'Location time zone',
		ru: 'Часовой пояс локации'
	}
}
